export default {
  common: {
    requests: 'リクエスト',
    request: 'リクエスト',
    loading: '読み込み中...',
    signUp: 'サインアップ',
    logOut: 'ログアウト',
    seeAll: 'すべて表示',
    follow: 'フォロー',
    unfollow: 'フォロー解除',
    email: '電子メール',
    fullName: 'フルネーム',
    password: 'パスワード',
    next: '次へ',
    continue: '続ける',
    addNew: '新規追加',
    type: '種類',
    typeYourMessage: 'メッセージを入力してください',
    yourMessage: '自分のメッセージ',
    message: 'メッセージ',
    shoutOut: 'シャウトアウト',
    story: 'ストーリー',
    chat: 'チャット',
    featureComingSoon: 'この機能は、まもなく利用可能になります。',
    okay: 'はい',
    react: 'リアクション',
    send: '送信',
    delete: '削除',
    cancel: 'キャンセル',
    yes: 'はい',
    no: 'いいえ',
    search: '検索',
    back: '戻る',
    goToHome: 'ホームに移動',
    addShoutout: 'シャウトアウトを追加',
    player: 'プレイヤー',
    text: 'テキスト',
    video: 'ビデオ',
    comment: 'コメント',
    team: 'チーム',
    country: '国',
    city: '都市',
    userName: 'ユーザー名',
    following: 'フォロー中',
    followers: 'フォロワー数',
    referals: '紹介',
    athletes: 'アスリート',
    shoutouts: 'シャウトアウト',
    showMore: 'もっと見る',
    showLess: '表示を減らす',
    sport: 'スポーツ',
    position: 'ポジション',
    league: 'リーグ',
    info: '情報',
    repost: '再投稿',
    share: 'シェア',
    confirmed: '確認済み',
    refused: '拒否された',
    pending: '保留中',
    canceled: 'キャンセル済み',
    trending: 'トレンディング',
    latest: '最新',
    noData: 'データなし',
    from: 'より',
    to: 'へ',
    settings: '設定',
    areYouSure: '確かですか',
    profile: 'プロフィール',
    accept: '承諾',
    refuse: 'すべて拒否',
    missing: '不明',
    select: '選択',
    currency: '通貨',
    zipCode: '郵便番号',
    goBack: '戻る',
    done: '完了',
    remove: '削除する',
    date: '日付',
    description: '説明',
    amount: '金額',
    upload: 'アップロード',
    getApp: 'アプリを取得',
    today: '本日',
    yesterday: '昨日',
    tomorrow: '明日',
    confirm: '確定',
    continue: '続ける',
    confirmAll: 'すべて承諾',
    login: 'ログイン',
    ad: '広告',
    aboutUs: '会社概要',
    fan: 'ファン',
    athlete: 'アスリート',
    stats: '統計情報',
    posts: '投稿',
    store: 'ストア',
    or: 'または',
    and: 'と',
    byRegisteringAgree: '登録すると、以下に同意したことになります:',
    shoutout: 'シャウト',
    proceed: '進む',
    dismiss: '閉じる',
    save: '保存',
    discard: '廃棄',
    submit: '送信',
    live: 'ライブ',
    openInbox: '受信トレイを開く',
    home: 'ホーム',
    searchDotDotDot: '検索...',
    subscribers: '購読者',
    subscribed: '購読済み',
    subscribe: '購読',
    unsubscribe: '配信停止',
    fans: 'ファン',
    teams: 'チーム',
    setup: 'セットアップ',
    feed: 'フィード',
    messages: 'メッセージ',
    earlier: '先ほどの',
    apply: '申し込み',
    openInApp: 'アプリで開く',
    oneOnOnes: '1対1',
    sort: '並び替え',
    comingSoon: '近日公開',
    goLive: 'ライブ配信を開始',
    total: '合計',
    pay: '{{amount}}を支払う',
    free: '無料',
    location: '所在地',
    countries: '国名',
    more: 'もっとその',
    less: '少ない',
    block: 'ブロック',
    unblock: 'ブロックを解除する',
    privacyPolicy: 'プライバシーポリシー',
    termsAndConditions: '規約と条件',
    createNew: '新しく作る',
    game: 'ゲーム',
    unlock: 'アンロック',
    post: 'ポストする',
    uploadFile: 'ファイルのアップロード',
    checkIn: 'チェックイン',
    unregisteredType: '入力は登録されていません',
    required: '必須',
    create: '作成',
    reply: '返信',
    caption: 'キャプション',
    optional: '任意',
    face2face: 'Face2Face',
    adPlayaz: 'AdPlayaz',
    activateFancamLive: 'ファンカムリアクトを開始',
    activateFancamChallenge: 'ファンカムチャレンジを開始',
    playToWinPoll: 'プレイ・トゥ・ウィン：投票',
    playToWinQuickQuiz: 'プレイ・トゥ・ウィン：クイック クイズ',
    predictScore: 'スコアを予測',
    noPosts: '投稿はありません',
    noShoutouts: 'シャウトアウトなし',
    updateNow: '今すぐ更新',
    goHome: 'ホームへ'
  },
  gloryBoard: {
    title: 'マッチデー GloryBoard',
    close: '閉じる',
    // TODO: placeholder English text — awaiting real Japanese translation for the new 3-line copy.
    weeklyWinnerHeadingFirst: 'Congratulations, {{name}}! 🏆',
    weeklyWinnerAchievementFirst: "You finished 1st on this week's Match-Day Glory Board.",
    weeklyWinnerSupportingFirst: 'Defend your spot next week and invite your friends to compete.',
    weeklyWinnerHeadingSecond: 'Congratulations, {{name}}! 🥈',
    weeklyWinnerAchievementSecond: "You finished 2nd on this week's Match-Day Glory Board.",
    weeklyWinnerSupportingSecond: 'Aim for the top spot next week and invite your friends to compete.',
    weeklyWinnerHeadingThird: 'Congratulations, {{name}}! 🥉',
    weeklyWinnerAchievementThird: "You finished 3rd on this week's Match-Day Glory Board.",
    weeklyWinnerSupportingThird: 'Climb even higher next week and invite your friends to compete.'
  },
  sports: {
    americanFootball: 'アメフト',
    baseball: '野球',
    basketball: 'バスケットボール',
    boxing: 'ボクシング',
    cricket: 'クリケット',
    soccer: 'サッカー',
    mma: '総合格闘技',
    race: 'レースカーの運転',
    tennis: 'テニス',
    carRace: 'カーレース',
    acrobatics: 'アクロバット',
    airSports: 'エアスポーツ',
    archery: 'アーチェリー',
    combatSports: '格闘技',
    cycling: 'サイクリング',
    cueSports: 'ビリヤード',
    equestrianSports: '馬術',
    golf: 'ゴルフ',
    handball: 'ハンドボール',
    iceSports: '氷上スポーツ',
    lacrosse: 'ラクロス',
    polo: 'ポロ',
    weightlifting: '重量挙げ',
    rowing: '漕艇',
    softball: 'ソフトボール',
    rugby: 'ラグビー',
    volleyball: 'バレーボール',
    coachingMentoring: 'コーチングとメンタリング',
    figureSkating: 'フィギュアスケート',
    formula1: 'フォーミュラ1',
    gymnastics: '体操',
    hockey: 'ホッケー',
    kickboxing: 'キックボクシング',
    motorSports: 'モータースポーツ',
    muayThai: 'ムエタイ',
    olympics: 'オリンピック',
    poleSports: 'ポールスポーツ',
    sportsInfluencer: 'スポーツ インフルエンサー',
    swimming: '水泳',
    trackField: '陸上競技',
    visualArtist: 'ビジュアルアーティスト',
    wheelchairRugby: '車いすラグビー',
    wrestling: 'レスリング',
    iceHockey: 'アイスホッケー',
    alpineSkiing: 'アルペンスキー',
    flagFootball: 'フラッグフットボール',
    climbing: 'クライミング',
    badminton: 'バドミントン',
    motorcycleRacing: 'モーターサイクル・レース'
  },
  levels: {
    interested: '興味がある',
    beginner: '初心者',
    amateur: 'アマチュア',
    intermediate: '中級',
    expert: 'エキスパート',
    retired: '引退した'
  },
  auth: {
    sponsorConsent: 'スポンサーからの案内を受け取ることに同意します',
    signUpFacebook: 'Facebookでサインアップ',
    signUpGoogle: 'Google でサインアップ',
    signUpPaypal: 'PayPalでサインアップ',
    forgottenPassword: 'パスワードをお忘れの方',
    logInFacebook: 'Facebookでログインする',
    logInGoogle: 'Google でログインする',
    logInPaypal: 'PayPalでログインする',
    dontHaveAccount: 'アカウントをお持ちではありませんか?',
    mustContain8Characters: '少なくとも 8 文字が含まれている必要があります。',
    alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
    passwordReset: 'パスワードのリセット',
    resetInstructions:
      'アカウントに関連付けられているメールアドレスを入力すると、パスワードの再設定手順が送信されます。',
    sendRecoveryEmail: '回復メールを送信する',
    backTo: '戻る',
    logIn: 'ログイン',
    checkEmail: 'メールアドレスを確認してください',
    noAccount: '関連付けられたアカウントはありません',
    pleaseTryAnother: '別のアドレスを試してください。',
    tryAnother: '別のメールアドレスをつかってください。',
    emailSent: '回復メールを送信しました',
    checkEmailInstructions:
      '受信箱（および迷惑メールフォルダ）を確認し、パスワードの再設定を行うための手順を確認してください。',
    createNewPassword: '新しいパスワードを作成する',
    newPassword: '新しいパスワード',
    confirmPassword: 'パスワードの確認',
    resetPassword: 'パスワードのリセット',
    validateYourEmail: 'メールアドレスを検証する',
    validateEmailInstructions:
      '新しいP4Pアカウントを有効にするために、メールアドレスの検証が必要です。',
    confirmEmail: 'メールアドレスの確認',
    validationEmailSent: '確認メールを送信しました',
    checkInboxToValidateEmail:
      '受信箱（および迷惑メールフォルダ）を確認の上、メールにある指示に従い認証してください。',
    getTheApp: 'アプリを入手する',
    accountLocked: 'あなたのアカウントはロックされています',
    accountLockedDesc:
      '間違った認証情報で複数回アクセスが試行されたため、アカウントがロックされました。パスワードをリセットするには、受信トレイを確認してください。',
    checkInbox: '受信トレイを確認する',
    youAcceptTerms:
      '登録またはログインすることにより、利用規約およびプライバシーポリシーに同意したものとみなされます。',
    logInApple: 'Appleでログイン',
    signUpApple: 'アップルに登録する',
    invalidEmail: '無効なメール形式です。',
    promptAuthMsg: 'この操作を行うには、アカウントを作成する必要があります。'
  },
  messages: {
    newMessages: '新着メッセージ',
    newGroup: '新グループ',
    favorites: 'お気に入り',
    favoritesAtTop: '上位のお気に入り',
    favoritesOnly: 'お気に入りのみ',
    excludeHidden: '非表示を除く',
    showHidden: 'もっと見る',
    hiddenChats: '非表示のチャット',
    message: 'メッセージ',
    addChat: 'チャットを追加',
    searchFriends: '友達を検索する',
    createdGroup: '{{group}}がこのグループを作成しました',
    totalMessageSingular: '1 件の新しいメッセージ',
    totalMessages: '{{totalMessageCount}}件の新しいメッセージ',
    noChats: '利用できるチャットはありません。',
    noChatSelected: 'チャットが選択されていません。',
    messageDotDotDot: 'メッセージ',
    noChatYet: 'ここにはまだチャットがありません...',
    searchFriendsGroups: '友人やグループを検索する...',
    selectFriend: '友達を選択',
    groupChatName: 'グループチャット名',
    startChat: 'チャットを開始',
    youNeedSub: 'メッセージを送るには、{{name}}を購読する必要があります。',
    youBlocked: 'このユーザーをブロックしました'
  },
  home: {
    latestPosts: '最新の投稿',
    confirmed: '確認済み',
    playazRunsSafeEnvironment: 'Playazは安全な環境を運営しています',
    connectionsConverstationsFollowedAthletes:
      '同じ興味を持つ者同士で、会話、グループ ミーティング、フォローしているアスリートからの学習を行うことができます。',
    myPosts: '自分のポスト',
    accountsToFollow: 'フォローするアカウント',
    comingUp: '今後の予定',
    gloriousWinners: '栄光の勝者たち',
    todaysGames: '今日の試合',
    athleteHighlights: 'アスリートのハイライト',
    fanHighlights: 'ファンのハイライト',
    todaysMatches: '今日の試合'
  },
  add: {
    followers: 'フォロワー数',
    subscribers: '購読者',
    onlyMe: 'あなたのみ',
    photoVideo: '写真/ビデオ',
    tag: 'タグ付け',
    editMedia: 'メディアの編集',
    tapCrop: '画像をタップしてトリミングします。',
    gallery: 'ギャラリー',
    addMultiple: '複数追加',
    shoutOutTo: 'へのエール',
    whereItHappens: '発生場所',
    shouldAcceptTerms: '利用規約への同意が必要です。',
    summary: '概要',
    total: '合計',
    iAcceptTerms: '利用規約に従い、アスリートの確認後、上記の金額が請求されることに同意します',
    post: 'ポストする',
    enterYoutubeLink: 'Youtubeのリンクを入力',
    tagFriends: '友達をタグ付けする',
    shareWith: 'と共有する',
    everyone: 'みんな',
    peopleFollowBack: 'フォローバックしたユーザーのみ',
    linkToVideo: '動画へのリンク',
    swipeRightPurchase: '右にスワイプして購入',
    uploadMedia: 'メディアをアップロードする',
    shareLink: 'リンクをシェアする',
    correctYoutubeLink: '正しい Youtube リンクを追加してください。',
    writeCaption: 'キャプションを書く',
    selectionsWillRemove: '投稿できる動画は 1 つだけです。他の選択は削除されます。続行しますか？',
    selectVideo: 'ビデオを選択する',
    onlySingleVideo: '現在、投稿できる動画は 1 つです。',
    upToAMinutes: '動画の長さは最大1分までです。',
    text: 'テキスト',
    video: 'ビデオ',
    tagPeople: 'タグ付けする',
    enterLink: 'リンクを入力する',
    linkToOriginalPost: '元の投稿へのリンク',
    pasteForPreview: 'リンクを貼り付けて、投稿のプレビューを表示します',
    createPost: '投稿を作成',
    recent: '最近の',
    noUserFound: '該当するユーザーは見つかりませんでした。',
    searchResults: '検索結果',
    storyPublished: 'ストーリー公開！',
    live: 'ライブ',
    shoutout: 'シャウト',
    addPhotosAndVideos: '写真とビデオを追加する',
    addLocation: '場所を追加',
    onlyForSubscribers: 'サブスクライバーのみ',
    photosAndVideos: '写真とビデオ',
    selectUpTo10: '10個まで選択',
    suggested: '推奨',
    shoutoutTo: 'へシャウトアウト',
    createShoutout: 'シャウトアウトを作成',
    newShoutout: '新しいシャウトアウト',
    tapOrHold: 'タップで写真、ホールドでビデオ',
    tapGoLive: 'タップしてライブ配信',
    addNewPost: '新しい投稿を追加する',
    addNewShoutout: '新しいシャウトを追加',
    fileFormats: 'JPEG、PNG、MP4、WebM、またはOggファイル形式',
    create: '作成',
    correctLink: '正しいリンクを追加してください。',
    addShoutout: 'シャウトアウトを追加',
    teamOrPlayer: 'チームまたは選手',
    team: 'チーム',
    startStreaming: 'ストリーミングを開始',
    createNewShoutout: '新規シャウトアウト作成',
    createNewPost: '新規投稿作成',
    selectFile: 'ファイルを選択'
  },
  browse: {
    trySearchAthlete: 'アスリート、チーム、またはハッシュタグを検索してみてください',
    basedYourPreferences: 'あなたの好みに合わせた、おすすめのアスリートやファンをご紹介します。',
    erlingHaaland: 'アーリング・ハーランド',
    parisSaintGermain: 'パリ・サンジェルマン',
    trendingPosts: '話題の投稿',
    chooseSportAndFavoriteTeam:
      'スポーツを選択し、お気に入りのアスリート チームを選んで最新情報を入手してください。',
    trendingTeams: 'トレンド投稿',
    seeTeamsYourFellow: '仲間のファンやアスリートが現在フォローしているチームを表示します。',
    atalanta: 'アタランタ',
    serieaFootballClub: 'セリエ A サッカークラブ',
    browse: 'ブラウズ',
    athletesOnPlatform: 'P4P のアスリート',
    fansOnPlatform: 'P4P のファン',
    upcomingEvents: '今後のイベント予定',
    eventsComingUpYourFavorite: 'お気に入りのスポーツ、チーム、アスリートに関するイベント情報',
    superBantamweight: 'スーパーバンタム級',
    tiffanyVanSoestAlinePereira: 'ティファニー・ヴァン・ソースト - アライン・ペレイラ',
    chicagoVenue: 'シカゴ、シカゴ会場',
    suggestedAthletes: 'おすすめのアスリート',
    suggestedFans: 'おすすめのファン',
    suggestedAccounts: 'おすすめのアカウント',
    newAppHasArrived: '新しいアプリが届きました',
    newAppDesc:
      '皆様からのご意見をもとに、P4P体験をより充実させました。アップデートされたAPPをお楽しみいただき、さらなるアップデートにご期待ください。',
    seeTheApp: 'アプリを見る',
    postCountSingular: '1件のポスト',
    postCountPlural: '投稿数{{count}}',
    recent: '最近の',
    top: 'トップ',
    athletes: 'アスリート',
    teams: 'チーム',
    tags: 'タグ',
    fans: 'ファン',
    trendingShoutouts: '注目のシャウト',
    goBrowse: 'ブラウズする',
    follower: 'フォロワー',
    followers: 'フォロワー',
    todaysGames: '今日の試合',
    trendingAthletes: '注目のアスリート',
    trendingFans: '注目のファン',
    allAthletes: '全アスリート',
    allFans: 'すべてのファン',
    sortBy: '並び替え',
    name: '名前',
    popularity: '人気度',
    recentlyRegistered: '最近の登録',
    filterByConnection: '接続先で絞り込む',
    showAll: 'すべて表示',
    showOnlyConnect: '接続可能なアスリートだけを表示する',
    teamsOnPlatform: 'P4P のチーム',
    allTeams: '全チーム',
    todaysMatches: '今日の試合'
  },
  chat: {
    muteNotifications: '通知をミュートする',
    removeFavorites: 'お気に入りから削除',
    addFavorites: 'お気に入りに追加',
    clearChatHistory: 'チャット履歴を消去する',
    youCannotAction: 'この操作を元に戻すことはできません。',
    deleteConversationWith: 'との会話を削除する。 ',
    deleteConversation: '会話を削除',
    unhideChat: 'チャットを再表示',
    hideChat: 'チャットを非表示',
    clearHistory: '履歴をクリア',
    noResults: '結果がありません...',
    noMessagesYet: 'ここにはまだメッセージはありません...',
    returnChat: 'チャットに戻る',
    searchMessages: 'メッセージを検索...',
    clearConfirmation: '本当にこのチャットを消去しますか？',
    deleteConfirmation: 'このチャットを削除しますか?',
    block: 'ブロック',
    disableSound: 'サウンドを無効にする',
    muteNotificationsFor: '通知をミュートする...',
    thirtyMinutes: '30分',
    oneHour: '1時間',
    oneDay: '1日間',
    oneWeek: '1週間',
    oneMonth: '1ヶ月',
    muteForever: '永久にミュート'
  },
  comments: {
    succesfullyReactedPost: 'この投稿に正常に反応しました。',
    beFirstReaction: '最初に反応してみましょう',
    comments: 'コメント',
    noComments: 'コメントなし',
    comment: 'コメント'
  },
  connect: {
    endOneOnOneWith: '1対1が終了します',
    youWontGoBackCall: 'この有料通話に戻ることはできません。',
    sayGoodBye: 'さよならを言う',
    timeToWrapUp: 'まとめの時間',
    oneOnOneCall: '1 対 1 の通話',
    setupConnect: '1 対 1 接続のセットアップ'
  },
  connectConfirmations: {
    cancelOneOnOne: '1対1をキャンセル',
    unfortunatelyCanceled: '残念ながら、 {{name}}との 1 対 1 の接続はキャンセルされました。',
    timeToStart: '{{name}}との 15 分間の１対１セッションを開始する時間です。',
    swipeCancel: '右にスワイプして接続をキャンセル',
    wantCancelOneOnOne: '1対1をキャンセルしますか？',
    youWillPay:
      '一旦行った予約をキャンセルすることはできません。キャンセルの場合は料金が発生します。',
    fanWillGet: 'これは元に戻すことができません。ファンの方には100％返金されます ({{amount}})',
    swipeRightStart: '右にスワイプして接続を開始します',
    oneOnOneConnectEnded: '1対1コネクトが終了しました',
    '15minCall':
      '{{name}}さんとの 15 分間通話で、お気に入りのアスリートとエキサイティングな会話ができたことを願っています。',
    bookAnotherOneOnOne: '他の1対1を予約する',
    refuseOneOnOne: '1対1の拒否',
    wantRefuseOneOnOne: '{{name}}との1対1を拒否しますか？',
    swipeRightRefuseConnect: '右にスワイプして接続をキャンセル',
    '15minCallWithAthlete':
      '{{name}}さんとの 15 分間通話で、お気に入りのアスリートとエキサイティングな会話ができたことを願っています。',
    waitingInLobby: 'ロビーで待機中...。',
    pleaseWaitUser: '<strong> {{name}} </strong>との 1 対 1 が始まるまでお待ちください。',
    refusedOneOnOneConnect: '1対1の接続が拒否されました',
    callSettings: '通話設定:'
  },
  settings: {
    referAnAthlete: 'アスリートを紹介する',
    upgradePlan: 'アップグレードプラン',
    settings: '設定',
    changePassword: 'パスワードを変更する',
    oldPassword: '古いパスワード',
    newPassword: '新しいパスワード',
    privacyAndSecurity: 'プライバシーとセキュリティ',
    profilePrivacySettings: 'プロフィールのプライバシー設定',
    whoCanView: 'あなたのプロフィール ページを閲覧できるのは誰ですか?',
    whoCanViewInfo: 'プロフィールページの情報タブは誰が見ることができますか？',
    whoCanViewBasicInfo: 'あなたの基本情報を閲覧できるのは誰ですか?',
    whoCanViewLocation: 'あなたの位置情報を見ることができるのは誰ですか？',
    whoCanViewActivities: 'プロフィール ページのアクティビティ セクションを閲覧できるのは誰ですか?',
    whoCanShare: 'あなたのウォールで投稿を共有できるのは誰ですか?',
    whoCanViewFriends: 'あなたの友達リストを閲覧できるのは誰ですか?',
    whoCanSendFriends: '私に友達リクエストを送ることができるのは誰ですか?',
    whoCanSendMessage: 'あなたにメッセージを送ることができるのは誰ですか?',
    whoCanViewPhotos: 'あなたのプロフィール ページで写真を閲覧できるのは誰ですか?',
    whoCanPokes: 'ポークを送ることができるのは誰ですか?',
    whoCanViewViewed: 'あなたのプロフィールを最近閲覧した人を確認できるのは誰ですか？',
    whoCanTag: '文字コンテキストで私をタグ付けできるのは誰ですか。',
    whoCanSeeDateOfBirth: 'あなたの生年月日を見ることができるのは誰ですか?',
    allowSharing: 'からの共有を許可',
    allowMentions: 'からのメンションを許可',
    allowTags: 'からのタグを許可',
    avilabilityPeriod: '利用可能期間',
    pleaseShare:
      '毎月の収益予想を教えてください。ファンはあなたのプロフィールでこれを見ることはありません。',
    customPeriod: 'カスタム期間...',
    from: 'より',
    to: 'へ',
    selectStart: '開始日を選択',
    selectEnd: '終了日を選択',
    total: '合計',
    pendingRequest: '保留中のリクエスト',
    invalid: '無効',
    today: '今日',
    months: '月',
    weeks: '週',
    setAvailability: '空き状況を設定する',
    fansWillOnly: 'ファンは、予約可能な枠の中で1対1のみ予約可能です',
    period: '期間',
    dayOfTheWeek: '曜日',
    daily: '毎日',
    thisWeek: '今週',
    thisMonth: '今月',
    availableTime: '利用可能時間',
    time: '時間',
    timeBetween: '接続間隔時間',
    breakDuration: '休憩時間',
    setAvailableTime: '時間を選択する',
    chooseATime: '1 対 1 のリクエストを受けたい時間帯を選択してください',
    weekDays: '平日',
    weekends: '週末',
    oneOnOneConnect: '1対1コネクト',
    save: '保存',
    search: '検索',
    subscriptions: 'サブスクリプション',
    emailNotifications: 'メール通知',
    languageAndCurrency: '言語と通貨',
    theme: 'テーマ',
    billing: 'お支払い情報',
    billingSubscription: '請求とサブスクリプション',
    accessBilling: 'お支払い情報にアクセスする',
    logOut: 'ログアウト',
    countryCode: '国コード',
    selectCountry: '国を選択する',
    passwordChangeSuccessful: 'パスワードの更新に成功しました。',
    confirmNewPassword: '新しいパスワードの確認',
    forgotPassword: 'パスワードを忘れた方はこちら',
    enableEmailNotifications: 'メール通知を有効にする',
    newComments: '新着コメント',
    newTags: '新規タグ',
    newSubscriptions: '新しいサブスクリプション',
    newFriends: '新しい友達',
    friendRequests: '友達申請',
    notificationForLikes: '「いいね」の通知',
    newMessages: '新着メッセージ',
    photosNotifications: '写真の通知',
    language: '言語',
    currency: '通貨',
    anyone: '誰でも',
    community: 'コミュニティ',
    friendsOnly: '友達のみ',
    noOne: '誰も',
    onlyAvailableViaApp: 'モバイルアプリ経由でのみ利用可能',
    darkMode: 'ダークモード',
    contentPrivacySettings: 'コンテンツのプライバシー設定',
    setAvailableTimeTo: '利用可能時間を設定する',
    chooseATimeTo: '1 対 1 のリクエストを受けたい時間帯を選択してください。',
    removeAccount: 'アカウント削除',
    accountPrivacy: 'アカウント',
    contactUs: 'お問い合わせ',
    leaveMessage: 'メッセージを残してください',
    howCanWeHelp: 'お困りですか？',
    stripeConnect: {
      title: 'Stripe Connect',
      description:
        'Stripeアカウントを連携して、サブスクリプション収益の分配を自動で受け取りましょう。',
      checkingStatus: '接続状況を確認中...',
      connected: '連携済み',
      notConnected: '未連携',
      notConnectedDesc:
        'Stripeアカウントを連携するまで、サブスクリプション収益の分配は適用されません。',
      chargesEnabled: '支払い有効',
      chargesDisabled: '支払い無効',
      payoutsEnabled: '振り込み有効',
      payoutsDisabled: '振り込み無効',
      disconnectHint: 'Stripeアカウントの連携を解除するには、管理者にお問い合わせください。',
      connectButton: 'Stripeアカウントを連携',
      connecting: 'リダイレクト中...',
      connectSuccess: 'Stripeアカウントが正常に連携されました！',
      errorInvalidTeam: 'OAuthコールバックにて無効なチームIDです。',
      errorNoAccountId: 'OAuthからStripeアカウントが返されませんでした。',
      errorTeamNotFound: 'OAuthコールバック中にチームが見つかりませんでした。',
      errorOAuthFailed: 'Stripe OAuthに失敗しました。もう一度お試しください。',
      errorGeneric: 'Stripe Connectに失敗しました。もう一度お試しください。',
      errorInitFailed: 'Stripe Connectの開始に失敗しました。もう一度お試しください。',
      errorNoUrl: 'Stripe OAuth URLを取得できませんでした。もう一度お試しください。',
      requestReplacement: 'アカウント変更をリクエスト',
      requestDeletion: '連携解除をリクエスト',
      requestReplacementTitle: 'Stripeアカウント変更のリクエスト',
      requestDeletionTitle: 'Stripeアカウント連携解除のリクエスト',
      requestReplacementPlaceholder:
        'Stripeアカウントを変更する理由を入力してください（例：法人変更、オーナー変更など）...',
      requestDeletionPlaceholder: 'Stripeアカウントの連携を解除する理由を入力してください...',
      replacementPending: 'アカウント変更をリクエスト済み — 管理者の承認待ち',
      deletionPending: '連携解除をリクエスト済み — 管理者の承認待ち',
      replacementRequested: 'アカウント変更リクエストを送信しました。管理者が確認します。',
      deletionRequested: '連携解除リクエストを送信しました。管理者が確認します。',
      replaceSuccess: 'Stripeアカウントが正常に変更されました！',
      errorInvalidReplacementToken: '変更リンクが無効か、すでに使用済みです。',
      errorReplacementTokenExpired:
        '変更リンクの有効期限が切れています。新しいリクエストを送信してください。',
      errorRegionNotSupported:
        'このStripeアカウントはプラットフォームのリージョンからの支払いを受け取ることができません。プラットフォームと同じリージョンのアカウントを連携してください。'
    }
  },
  scheduleConnect: {
    '15minutesCall': '15分間通話',
    thereIsNo: 'この日付の空きはありません。',
    selectTime: '時間を選択する',
    bookOneOnOne: '1対1を予約する',
    youAlreadyHave: 'あなたはすでにこのアスリートとつながっています。',
    scheduleAlreadyExist: 'スケジュールはすでに存在します',
    ad: '広告',
    nextAvailableSlot: '次に利用可能なスロット',
    noScheduleFound: 'スケジュールが見つかりません',
    thisUserHasnt:
      'このユーザーはまだスケジュールを設定していません。後日、改めてアクセスしてください。',
    schedule: 'スケジュール',
    today: '本日',
    tomorrow: '明日',
    weeks: '週',
    seeCalendar: 'カレンダーを見る',
    dateAndTime: '日時',
    edit: '編集',
    total: '合計：',
    asPerTheTerms: '利用規約に従い、アスリートの確認後、上記の金額が請求されることに同意します',
    sendRequest: 'リクエスト送信',
    oneOnOneRequest: '1 対 1 のリクエストが送信されました',
    afterTheAthleteAccepts:
      'アスリートがあなたのリクエストを承認すると、通知が届き、ダッシュボードに保留中の1対1が表示されます。',
    goToDashboard: 'ダッシュボードに移動',
    bookOtherOneOnOne: '他の1対1を予約する',
    proceed: '続行',
    searcAthletes: 'アスリート検索',
    notVerified: 'このプロフィールは確認済みのアスリートではありません。',
    bookOneOnOneTeam: 'Booking a Face2Face? Please select your favorite athlete. Thank you!',
    noBooked: '１対１がまだ予約されていません',
    bookedYet: '1対1を予約しましたか',
    selectDay: '日付を選択してください',
    nextOneOnOnes: '次の１対１',
    noResults:
      '選手たちは皆、スケジュールが詰まっています。空きは定期的にありますので、またお越しください。'
  },
  connectsDashboard: {
    byFan: 'ファン別',
    byAthlete: 'アスリート別',
    pending: '保留中',
    confirmed: '確認済み',
    rejected: '拒否',
    timeBooked: '予約時間',
    refuseOneOnOneConnect: 'すべての1対1コネクトを拒否する',
    refuseAll: 'すべて拒否する',
    oneOnOneConnect: '1対1のコネクト',
    bookAgain: '再度予約する'
  },
  dashboard: {
    monthlyTarget: '月次目標',
    setMonthlyRevenueTarget: '月間収益目標がまだ設定されていません。',
    useAthleteRefferalCodes: 'アスリート紹介コードを使用してチームを成長させる',
    setupRateAndAvailability: '1 対 1 のリクエスト取得のため、レートとスケジュールを設定します。',
    shoutouts: 'シャウトアウト',
    vipConnect: 'VIPコネクト',
    week: '週',
    month: '月',
    year: '年',
    all: 'すべて',
    custom: 'カスタム...',
    total: '合計',
    dashboard: 'ダッシュボード',
    referrals: '紹介',
    income: '収入',
    users: 'ユーザ数',
    subscribed: '購読済み',
    progress: '進捗',
    followers: 'フォロワー数',
    advertising: '広告',
    views: '閲覧数',
    number: '数',
    athleteEmail: 'アスリートのメールアドレス',
    meetings: 'ミーティング',
    itemsSold: '販売アイテム',
    store: 'ストア',
    editMonthlyTarget: '月次目標の編集',
    inviteToGrow: 'メールアドレスを入力して、チームを成長させるための招待状を送信します。',
    inviteAthletes: 'アスリートを招待する',
    follower: 'フォロワー数'
  },
  editProfile: {
    sport: 'スポーツ',
    selectSuport: 'スポーツを選択する',
    favoriteTeam: '一番好きなチーム',
    selectTeam: 'チームを選択する',
    favoritePlayer: '一番好きな選手',
    selectPlayer: 'プレイヤーの選択する',
    addMoreSport: 'スポーツを追加',
    editProfile: 'プロフィール編集',
    dateOfBirth: '生年月日',
    bio: '自己紹介（経歴）',
    mySport: '私のスポーツ',
    mySports: '私のスポーツ',
    position: 'ポジション',
    selectPosition: 'ポジションを選択する',
    level: 'レベル',
    selectLevel: 'レベルを選択する',
    personalInformation: '自分のプロフィール',
    myGender: '性別',
    female: '女性',
    male: '男性',
    other: 'その他',
    imFrom: '出身地',
    yourPhoneNumber: '電話番号'
  },
  profile: {
    wantToConnect: '直接コンタクトを取りたい方はこちら',
    favoriteSports: '一番好きなスポーツ',
    favoriteAthlete: '一番好きなアスリート',
    referAndReward: 'アスリートを紹介して報酬を得る',
    invitePeople: 'アスリートを招待する',
    earnMoreReferralFees: 'あなたの周りのアスリートを招待して、より多くの紹介料を獲得しましょう',
    inviteAthleteFan: 'アスリートとファンを招待する',
    typeEmailToInvite: 'メールアドレスを入力して、チームを応援するための招待状を送信します。',
    athleteEmail: 'アスリートのメール',
    doesntExists: 'このユーザーは存在しません。',
    shoutouts: 'Shoutouts',
    mySports: '私のスポーツ',
    myEquipment: '私の出品物',
    relatedProducts: '関連製品',
    bidForEquipment: '私の出品物を落札してください',
    goToAppSettings: 'アプリ設定に移動',
    followRequired: '{{feature}}を使用するには、まず{{teamName}}をフォローしてください。',
    recentShoutouts: '最近のシャウトアウト',
    recentUpdates: '最新情報',
    trendingPosts: 'トレンド投稿',
    following: 'フォロー中',
    userNotFound: 'ユーザー @{{username}} が見つかりません',
    searchFriendsAndFollowers: '友達やフォロワーを検索',
    noUpdatesYet: '{{name}}の投稿はまだありません',
    noPostsYet: '{{name}}の投稿はまだありません',
    followToKnowFirst:
      '{{name}}をフォローして、ポッドキャストやライブストリーミングなどの最新情報をいち早く知ることができます。',
    encourage: '彼らを励ますために、気軽にエールを送ってみましょう。',
    threeMonthsAccess: '3か月間、無制限のクローズドアアクセスが可能です',
    enjoyFreeAccess: 'アスリート限定コンテンツをお楽しみください。',
    repostHeader: '{{owner}}が{{originalOwner}}の投稿をシェアしました',
    nowFollowing: '{{name}}をフォロー中',
    sureToRemove: '本当にアカウントを削除しますか？このアクションは元に戻せません。',
    getUnlimited: '無制限のコンテンツを入手',
    getUnlimitedDesc: 'お気に入りのアスリートに登録して、限定コンテンツの最新情報をゲットしよう。',
    verifiedAthlete: '検証済みアスリート',
    callToAction: '行動喚起をシェア',
    mediaShare: 'メディア共有',
    selectEngagement: 'エンゲージメントを選択',
    writeCaption: 'キャプションを書く',
    engagement: 'エンゲージメント'
  },
  notifications: {
    notifications: '通知',
    noNotificationsTitle: '通知はまだありません',
    noNotifications: 'すべて確認済みです — 新しい通知はここに表示されます。',
    comingUpConnect: '5 分後に{{sender}}と 1 対 1 で話せます',
    connectRequest: '{{sender}}からの 1 対 1 のリクエスト',
    connectStatus: '{{sender}}と１対１で{{status}}',
    connectStarting: 'これからの15分間で{{sender}}との1対1を開始します。',
    commentedToPost: 'ポストにコメントした',
    commentedToSportChat: '<strong>{{sender}}</strong> \ncommented on your sport chat',
    reactedToPost: 'あなたの投稿に反応しました',
    reactedToShoutout: 'あなたのシャウトアウトに反応しました',
    amountReactedToPost: '{{amount}}人があなたの投稿に反応しました',
    aNewShoutout: '新しいシャウトアウトがあります',
    newShoutouts: '{{amount}}件の新しいシャウトアウトがあります',
    shoutoutReaction: '{{sender}}があなたのシャウトアウトに反応しました',
    startedFollowing: '{{sender}}さんがあなたをフォローし始めました',
    amountStartedFollowing: '{{amount}}人のユーザーがあなたをフォローし始めました',
    newSub: '新しいサブスクライバーがいます',
    newSubs: '{{amount}}人のサブスクライバーがいます',
    newRequests: '{{amount}}件の新しい1対1リクエスト',
    newFollower: 'あなたをファローした',
    taggedInPost: '<strong> {{sender}} <\/strong>\n投稿にあなたをタグ付けしました',
    mentionedInPost: '<strong> {{sender}} <\/strong>\n投稿の中であなたについて言及しました',
    commentTagged: '<strong> {{sender}} <\/strong>\nコメントであなたをタグ付けしました',
    p4pMonetizingYourBrand: 'P4Pがあなたのブランド価値を収益化しています！',
    fanRequestingShoutout: 'ファンの方からのシャウトアウトリクエストがあります。',
    view: '見る',
    congratulations: 'おめでとうございます！',
    yourFavoriteAthleteCompletedYourRequest:
      'あなたのお気に入りのアスリートがあなたのシャウトアウトリクエストを完了しました。',
    sorryFavoriteAthleteCurrentlyUnavailable:
      'すみませんが、あなたのお気に入りのアスリートはただいま対応できません。他のアスリートを選択するか、時間をおいて再度お試しください。',
    sender: '<strong>{{sender}}</strong>',
    sportChatCommentTagged: '<strong>{{sender}}</strong> \ntagged you in their sport chat comment',
    startedSubscribing: '<strong> {{sender}} <\/strong>\n現在あなたに登録されています',
    contentRemoved:
      'あなたの<strong>{{content}}</strong>はコミュニティガイドライン違反（{{reason}}）のため削除されました',
    contentRemovedNoReason:
      'あなたの<strong>{{content}}</strong>はコミュニティガイドライン違反のため削除されました',
    contentWarned:
      'あなたの<strong>{{content}}</strong>は公開されましたが、コミュニティガイドライン（{{reason}}）に違反している可能性があります',
    contentWarnedNoReason:
      'あなたの<strong>{{content}}</strong>は公開されましたが、コミュニティガイドラインに違反している可能性があります',
    moderatedContent: {
      post: '投稿',
      comment: 'コメント',
      fanChat: 'チャット投稿',
      shoutout: 'シャウトアウト',
      fanCamPhoto: 'FanCam写真',
      story: 'ストーリー',
      profileDescription: 'プロフィール紹介文',
      username: 'ユーザー名',
      profileImage: 'プロフィール写真',
      content: 'コンテンツ'
    }
  },
  repost: {
    tagFriends: '友達をタグする',
    repost: 'シェア',
    create: '作成',
    yourComment: 'あなたのコメント',
    shareWith: 'シェア',
    everyone: '皆さん',
    OnlyPeopleIFollowBack: 'フォローバックしたユーザーのみ'
  },
  onBoarding: {
    everybody: '皆さんが',
    plays: '遊ぶ',
    better: 'より良く',
    together: '一緒に',
    favoriteSports: '好きなスポーツ',
    chooseSports:
      'スポーツを選択し、お気に入りのアスリートのチームを選んで最新情報を入手してください。',
    selectSport: 'スポーツを選択する',
    sport: 'スポーツ',
    favoriteTeam: '一番好きなチーム',
    selectTeam: 'チームを選択する',
    favoritePlayer: '一番好きな選手',
    selectPlayer: 'プレイヤーの選択する',
    addMoreSport: 'スポーツを追加',
    getStarted: '始めましょう',
    youreAlmostThere: 'あと少し',
    tellUsAboutYourself:
      '最も適切なフィードバックとアップデートを取得するために、あなたについて教えてください。',
    imFrom: '出身地',
    yourPhoneNumber: '電話番号',
    dateOfBirth: '生年月日',
    monthlyRevenueTarget: '月間収益目標',
    pleaseShareYour:
      '毎月の収益予想を教えてください。自分のプロフィールには表示されません。（ファンが見ることはできません）',
    next: '次へ',
    skipThisStep: 'このステップをスキップする',
    yourSports: '自分のスポーツ',
    chooseASport: 'スポーツとポジションを選択してください',
    mySport: '私のスポーツ',
    position: 'ポジション',
    selectPosition: 'ポジションを選択',
    addSecondarySport: 'セカンダリースポーツを追加',
    chooseSportsYou: '興味のあるスポーツを選んでください。',
    skipAndGet: 'スキップして、はじめる',
    connectDirectlyWith: '好きなアスリートや他のファンと直接つながることができます。',
    monetizeYourBrand: 'ファンと共に独自の世界を作り上げ、ブランドを収益化しよう',
    chooseAUsername: 'ユーザー名を選択する',
    referralCodeOptional: '紹介コード (オプション)',
    backTo: '戻る',
    logIn: 'ログイン',
    imAFan: '私はファンです',
    imAnAthlete: '私はアスリートです',
    createAnAccount: 'アカウントを作成する',
    searchTeams: 'チームを検索'
  },
  shoutout: {
    comingSoon: 'シャウトアウトは近日公開',
    comingSoonDesc:
      '世界中の有名なアスリートとコミュニケーションを取り、応援し、祝福するメッセージ（シャウトアウト）を送信します。',
    success: 'Shoutoutの送信に成功しました。',
    selectTeamOrAthete: 'チーム, アスリートを選ぶ',
    teamOrAthlete: 'チーム/ アスリート',
    writeShoutout: 'シャウトアウトを書く',
    createMatchDayShoutout: 'マッチデー シャウトアウトを作る',
    matchDayShoutouts: 'マッチデー シャウトアウト',
    shoutoutsFromAthletes: 'アスリートから',
    shoutoutsFromFans: 'ファンから',
    sentShoutout: 'Shoutoutを投稿しました！',
    shoutoutusage: '今週は{{limit}}件中{{used}}件のシャウトアウトを使用しました。'
  },
  shop: {
    comingSoon: 'ストアは近日オープン予定',
    comingSoonDesc:
      '有名アスリートのグッズ、イベントチケット、限定商品など、様々な商品を販売予定です。近日中にオープンのお知らせをいたします。'
  },
  header: {
    logOutConfirmation: 'ログアウトしますか？ログイン情報で後で再度ログインすることができます',
    upgradePlan: 'プランをアップグレードする'
  },
  post: {
    timestampYear: '年',
    timestampMonth: '月',
    timestampWeek: '週',
    timestampDays: '日',
    timestampHour: '時',
    timestampSecond: '秒',
    deletePost: '投稿を削除',
    editPost: '投稿を編集',
    reportPost: 'レポート投稿',
    areYouSure: '投稿を削除してもよろしいですか？',
    reportingSoon: 'レポートはまだご利用できません。後日、再度お試しください。',
    beingProcessed: 'このビデオは処理中ですので、後で戻ってきてください。'
  },
  billing: {
    billing: '請求',
    settings: '設定',
    history: '履歴',
    billingInformation: 'お支払い情報',
    paymentMethod: '支払方法',
    addPaymentMethod: 'お支払い方法を追加する',
    youNeedToAddMethod: 'お支払い方法を追加する必要があります',
    forYourPurches: 'お支払い方法を追加するために、Web アプリにリダイレクトされます。',
    goToWebApp: 'ウェブアプリにアクセスします',
    exp: '期限',
    removingCard: 'このカードを削除します',
    sureToRemove: '**** {{last4}} を削除してもよろしいですか?',
    noPaymentsYet: 'まだ支払いはありません',
    processedPaymentsHere: 'ここでは、処理された決済の一覧が表示されます。',
    shoutoutTo: '{{名前}}にシャウトアウトする',
    connectWith: '{{name}}と1対1のコネクト',
    connectRefused: '1対1のコネクトは{{name}}に拒否されました。',
    connectCanceledBy: '1対1のコネクトは{{name}}にキャンセルされました。',
    termsAndConditions: '利用規約に従い、p4pの確認時に上記の金額が請求されることに同意します',
    swipeRightToPurchase: '右にスワイプして購入',
    subscription: '{{name}}を購読する',
    productOrder: '商品のご注文',
    purchase: '購入',
    noActiveSubscription: 'アクティブなサブスクリプションはありません',
    subscribeToUnlock: 'プランを購読して、限定コンテンツや機能をアンロックしましょう。',
    activeSubscriptionCount: '{{count}}件のアクティブなサブスクリプション',
    activeSubscriptionCount_plural: '{{count}}件のアクティブなサブスクリプション',
    noSubscriptionsInFilter: 'このフィルターに一致するサブスクリプションはありません。',
    amount: '金額',
    cycle: '周期',
    nextPayment: '次回支払日',
    payment: '支払い',
    details: '詳細',
    viewDetails: '詳細を見る',
    expiresToday: '本日期限切れ',
    expiresInDays: '{{count}}日後に期限切れ',
    billingCycle: '請求サイクル',
    started: '開始日',
    currentPeriod: '現在の期間',
    renewals: '更新回数',
    provider: 'プロバイダー',
    includedFeatures: '含まれる機能',
    recentActivity: '最近のアクティビティ',
    downloadInvoice: '請求書をダウンロード',
    goBack: '戻る',
    cancelSubscription: 'サブスクリプションをキャンセル',
    scheduledForCancellation:
      '購読はキャンセルされました。現在の請求期間の終了までアクセスを維持できます。',
    cancelConfirmation:
      '{{team}}の{{plan}}サブスクリプションをキャンセルしてもよろしいですか？{{date}}まで引き続きアクセスできます。',
    cancelReasonLabel: 'キャンセルの理由（任意）',
    cancelReasonPlaceholder: 'キャンセルの理由をお聞かせください...',
    requestRefund: '返金をリクエスト',
    refundPending: '返金リクエスト済み — 承認待ち',
    refundApproved: '返金承認済み',
    refundRejected: '返金却下',
    refundPendingMessage:
      '現在、返金リクエストを審査中です。管理者の対応後にステータスを更新します。',
    refundApprovedMessage: '返金が承認されました。元のお支払い方法へ返金処理が行われます。',
    refundRejectedMessage: '返金リクエストは審査の結果、却下されました。',
    refundRequestPromptTitle: '返金をご希望ですか？',
    refundRequestPromptDesc:
      'お支払いが完了しているにもかかわらずサブスクリプションが有効化されなかった場合、返金申請ができます。',
    requestedOn: '申請日',
    processedOn: '処理日',
    refundReference: '参照ID',
    yourNote: 'あなたのメモ',
    adminMessage: '管理者メッセージ',
    upgradeSubscription: 'サブスクリプションをアップグレード',
    teamSubscription: 'チームサブスクリプション',
    updatePaymentMethod: 'お支払いに失敗しました。継続するにはお支払い方法を更新してください。',
    updatePaymentDetails: 'お支払い情報を更新',
    paymentUpdatedTitle: 'お支払い方法を更新しました',
    paymentUpdatedMessage: '新しいカードが保存されました。24時間以内に自動的に再決済されます。',
    contactSupport: 'サポートにお問い合わせください。',
    status_active: 'アクティブ',
    status_pending: '支払い待ち',
    status_retrying: '再試行中',
    status_suspended: '一時停止中',
    status_cancelled: 'キャンセル済み',
    status_failed: '失敗',
    status_refunded: '返金済み',
    pendingPaymentAction:
      'コンビニエンスストアでお支払いを完了してサブスクリプションを有効にしてください。',
    event_subscribed: '購読開始',
    event_renewed: '更新',
    event_upgraded: 'アップグレード',
    pointsEarned: '獲得ポイント：{{multiplier}} 倍',
    eventUpgradedTo: '{{plan}} へアップグレードされました。',
    eventUpgradedToInterval: '{{plan}}（{{interval}}）へアップグレードされました。',
    eventChangedTo: '{{plan}} に変更されました。',
    eventChangedToInterval: '{{plan}}（{{interval}}）に変更されました。',
    interval_monthly: '月額プラン',
    interval_yearly: '年額プラン',
    timeline: {
      totalPaid: '支払総額',
      currentPlan: '現在のご契約プラン',
      nextCharge: '次回の請求日',
      noFurtherCharge: '今後の請求はありません。',
      nextChargeOn: '{{date}} に {{amount}} が請求されます。',
      refunded: '返金済みです。',
      planWithInterval: '{{plan}}（{{interval}}）',
      subscribed: '{{plan}}（{{interval}}）にご加入いただきました。',
      subscribedPlain: '{{plan}} にご加入いただきました。',
      planOnly: '{{plan}}',
      switchedInterval: '{{plan}} を {{interval}} 請求へ変更しました。',
      upgradedTo: '{{plan}}（{{interval}}）へアップグレードされました。',
      changedTo: '{{plan}}（{{interval}}）に変更されました。',
      renewed: '{{plan}}（{{interval}}）が更新されました。',
      payment: '支払い',
      paymentFailed: '支払いに失敗しました。',
      suspended: 'サブスクリプションは一時停止されています。',
      cancelled: 'サブスクリプションは解約されました。',
      refundRequested: '返金が申請されました。',
      refundApproved: '返金が承認されました。',
      refundRejected: '返金が拒否されました。',
      covers: '対象期間：{{from}} 〜 {{to}}',
      details: '詳細を表示',
      hideDetails: '詳細を非表示',
      lineCredit: '前のプランの未使用期間がクレジットとして適用されました。',
      lineProration: 'プラン変更に伴う調整が行われました。',
      reconcileMatches: 'タイムラインは Stripe と一致しています。徴収額：{{amount}}',
      reconcileDiffers: 'タイムラインは Stripe と一致していません。表示：{{entries}}／Stripe：{{stripe}}',
      reconcileMissingHere: 'Stripe に存在し、このタイムラインに含まれていない請求書：{{ids}}',
      reconcileMissingStripe: 'このタイムラインに存在し、Stripe で支払い済みとして扱われていない請求書：{{ids}}',
      reconcileUnavailable: '現在 Stripe との照合ができませんでした。',
      systemEvents: 'システムイベント（{{count}} 件）',
      status: {
        paid: '支払い済み',
        noCharge: '請求なし',
        failed: '失敗',
        refunded: '返金済み',
      },
      admin: {
        invoice: '請求書',
        stripeFee: 'Stripe 手数料',
        platformShare: 'プラットフォーム分配額',
        teamTransfer: 'チーム送金',
        providerEvent: 'プロバイダーイベント',
        unverified: '未確認',
      },
    },
    event_downgraded: 'ダウングレード',
    event_payment_succeeded: '支払い成功',
    event_payment_failed: '支払い失敗',
    event_cancelled: 'キャンセル',
    event_renewal_failed: '更新失敗',
    event_refund_requested: '返金リクエスト',
    event_refund_approved: '返金承認',
    event_refund_rejected: '返金却下',
    refundTitle: '返金をリクエスト',
    refundDescription:
      '{{team}}の{{plan}}サブスクリプションの返金をリクエストします。お客様のリクエストは3〜5営業日以内に審査されます。',
    refundReasonLabel: '返金の理由',
    refundReasonPlaceholder: '返金リクエストの理由をご記入ください...',
    submitRequest: 'リクエストを送信'
  },
  revenueTarget: {
    none: 'なし',
    oneThousand: '千ドルまで',
    fiveThousand: '5千ドルまで',
    tenThousand: '1万ドルまで',
    hundredThousand: '10万ドルまで',
    oneMillion: '100万ドルまで',
    moreThanMillion: '100万ドル以上'
  },
  forgotPassword: {
    recoveryEmailSent: '回復メールを送信しました',
    checkYourInbox:
      '受信トレイ（および迷惑メールフォルダ）を確認し、パスワードの再設定を行うための手順を確認してください。',
    backToLogin: 'ログインに戻る',
    backToSettings: '設定に戻る',
    passwordReset: 'パスワードのリセット',
    enterEmail:
      'アカウントに関連付けられたメールアドレスを入力すると、パスワード回復の手順をお送りします。',
    sendRecovery: '回復メールを送信する',
    checkEmail: 'メールアドレスを確認する',
    noAccount: '関連付けられたアカウントはありません',
    anotherAddress: '別のメールアドレスをつかってください。',
    tryAnother: '別のメールを試してみる',
    createNewPassword: '新しいパスワードの作成',
    doesntMatch: '一致しません',
    newPassword: '新しいパスワード',
    resetPassword: 'パスワードのリセット',
    passwordRule1: '新しいパスワードは、以前のパスワードとは異なる必要があります。',
    passwordRule2: '8 文字以上 — 文字数が多いほど良い。',
    passwordRule3: '大文字と小文字を組み合わせたもの',
    passwordRule4: '文字と数字を組み合わせたもの',
    passwordRule5: '少なくとも 1 つの特殊文字 (例: !@ # ?）を使用してください'
  },
  p4pDay: {
    // 見出しはタイポグラフィ仕様に従い、どの言語でも英語表記のまま使います。
    headerLine1: 'P4P Day with',
    headerLine2: 'FC Tokyo',
    opening: 'Playaz4Playaz を起動しています…',
    notInstalled: '自動的に開かない場合は、下からアプリをダウンロードしてください。',
    desktop: 'スマートフォンでQRコードを読み取るか、下からアプリをダウンロードしてご参加ください。',
    followPrompt:
      'FC東京をフォローして、写真や動画を投稿するには、ログインまたは新規登録を行ってください。',
    giftTitle: 'P4Pデーのギフト',
    badgeOfTotal: '{{total}}枚の{{color}}バッジのうち #{{badgeNo}}',
    giftItemLabel: 'ギフト',
    giftItems: {
      stickers: 'ステッカー',
      keyChain: 'キーホルダー',
      pen: 'ペン'
    },
    fanIdLabel: 'ファンID',
    showAtBooth: 'P4Pデーのブースでこの画面をご提示ください。',
    noGift:
      'ご参加の時点でギフトはすべて配布済みでした。受け取れるギフトはありませんが、チームのフォローは完了しています。',
    notEnrolled: 'P4Pデーキャンペーンには参加していません。'
  },
  getTheApp: {
    header: 'スマートフォン用のplayaz4playazアプリをダウンロードする',
    setupAccount:
      'スマートフォン用のplayaz4playazアプリをダウンロードして、アカウントをセットアップしてください。'
  },
  openApp: {
    title: 'P4Pアプリを開いています…',
    body: 'アプリが開かない場合は、下のボタンをタップしてください。',
    open: 'アプリを開く',
    getIt: 'アプリをお持ちでない方はこちらから入手'
  },
  emailView: {
    title: 'P4Pからのメール',
    unavailable: 'このリンクは有効期限が切れているか、無効です。'
  },
  share: {
    repost: '再投稿',
    copyLink: 'リンクをコピー',
    viaMessage: 'メッセージでシェアする',
    toFb: 'Facebookにシェアする',
    toInst: 'Instaにシェアする',
    toTwit: 'Twitterにシェアする',
    toWhapp: 'WhatsAppにシェアする',
    toTelg: 'Telegramにシェア',
    viaEmail: 'メールでシェア',
    fb: 'Facebook',
    ig: 'Instagram',
    shareTo: '共有先'
  },
  verification: {
    verifyProfile: 'プロフィールを検証する',
    verifyProfile2: 'プロフィールの検証',
    accountNeedsVerification:
      'アカウントの検証が必要です。身分証明書を顔の横に置いた状態で自撮りしてください。尚、後でプロフィールから行うこともできます。',
    needVerification: '1 対 1 のコネクトに参加するには、アカウントの確認が必要です。',
    yourProfileVerified: 'プロフィールが確認済み',
    verificationRequested: '検証が要求されました',
    beingVerified:
      'プロフィールは24時間以内に確認されます。確認後、支払処理が完了した時点で１対１に参加ができます。',
    profileVerifiedDescription:
      '検証を完了していただきありがとうございます。これで、スケジュールされた1対1セッションに参加できます。'
  },
  events: {
    shoutouts: 'シャウトアウト',
    livescore: 'ライブスコア',
    pictures: '写真',
    stats: '統計',
    noShoutouts: 'このイベントにはまだシャウトアウトがありません',
    addShoutout: '今すぐ送信して、最初にシャウトアウトしましょう!'
  },
  games: {
    ht: 'ハーフタイム',
    ft: 'フールタイム',
    matchday: '{{round}} 戦目',
    roundOf16: 'ラウンド16',
    quarterFinal: '準々決勝',
    semiFinal: '準決勝',
    playOff: 'プレーオフ',
    playoffFinal: 'プレーオフ決勝',
    final: '決勝戦',
    preSeason: 'プレシーズン',
    playOffSemiFinal: 'プレーオフ準決勝',
    wantToShoutout: 'シャウトしたい？'
  },
  permissions: {
    permissionsBlocked: 'アクセスがブロックされました',
    goToYourSettings: '設定から{{permission}}を有効にしてください。',
    openSettings: '初期設定',
    camera: 'カメラ',
    microphone: 'マイク',
    gallery: 'ギャラリー',
    openCamera: 'カメラを開く'
  },
  store: {
    suggestedItems: 'おすすめのアイテム',
    liked: 'いいね',
    merchandise: '商品',
    tickets: 'チケット',
    fromSubscribed: '登録アスリートから',
    productDetails: '製品詳細',
    selectSize: 'サイズ選択',
    selectStock: 'タイプを選択',
    seeSizeGuide: 'サイズ表を見る',
    currentBid: '現在の入札状況',
    placeBid: '入札する',
    likedProducts: 'お気に商品の商品',
    noLiked: 'お気に入りの商品はまだありません',
    addToCart: 'カートに入れる',
    cart: 'カート',
    totalCost: '合計',
    checkout: 'チェックアウト',
    orderSuccessful: 'オーダー成功しました',
    size: 'サイズ',
    price: '価格',
    proceedToPayment: '決済に進む',
    sizeWithDesc: '{{size}} サイズ',
    clearAll: 'すべてクリア'
  },
  goLive: {
    onlineCount: '{{オンラインカウント}} オンラインのサブスクライバー',
    onlineCountFan: 'オンラインフォロワー{{onlineCount}}',
    watchingCount: '{{watchingCount}}視聴中',
    youAreLive: 'ライブです',
    streamIsFinished: 'ストリームが終了しました。',
    live: 'ライブ',
    end: '終了',
    comment: 'コメント',
    tapForGoLive: 'ライブ開始をタップ'
  },
  subscribe: {
    monthly: '毎月',
    annual: '年間',
    off: '{{amount}} % オフ',
    upToOff: '最大{{amount}} % オフ',
    athletesAndTeams: 'アスリートとチーム',
    subscribeFor: '１ヶ月{{amount}}で購読',
    subscriptionSummary: 'サブスクリプションの要約',
    introductoryOffer: '紹介オファー',
    annualDiscount: '年間割引を受ける場合は１年分が10ヶ月相当額に。',
    noResults: '一致する結果が見つかりませんでした。',
    teamFan: '{team}}のファン？',
    subscribeForTeam: '全チームアスリートを<strong>{{amount}}/月で</strong>サブスクライブする',
    seeAllAthletes: '{{number}}人のアスリートをすべて見る',
    subscribeModalTitle: 'お気に入りのアスリートやチームをサブスクライブする',
    subscribeModalDesc:
      'アスリートやチームの限定コンテンツをお楽しみください。 全プレーヤーへの アクセス取得は$5.99からお楽しみいただけます。',
    athletesToSubscribe: '購読するアスリート',
    numberAthletes: '{amount}}アスリート',
    cancelSubscription: 'サブスクリプションをキャンセルする',
    daysLeftInPeriod: '現在の期間はあと{{amount}}日です',
    sureToCancel: 'サブスクリプションをキャンセルしてもよろしいですか？',
    bundleSquad: '{{name}}分隊',
    remindMeLater: '後で思い出す'
  },
  americanFootball: {
    quarterback: 'クォーターバック',
    runningBack: 'ランニングバック（フルバック）',
    wideReceiver: 'ワイドレシーバー',
    tightEnd: 'タイトエンド',
    leftGuard: '左ガード',
    rightGuard: '右ガード',
    center: 'センター',
    leftTackle: '左タックル',
    rightTackle: '右タックル',
    noseTackle: 'ノーズタックル',
    defensiveTackles: 'ディフェンス・タックル',
    offensiveTackles: 'オフェンシブタックル',
    offensiveLineman: 'OL',
    middleLineBacker: 'ミドルラインバッカー',
    outsideLineBacker: 'OLB',
    defensiveBack: 'ディフェンスバック',
    flanker: 'フランカー',
    splitEnd: 'スプリット・エンド',
    kicker: 'キッカー',
    punter: 'パンター',
    cornerback: 'DB',
    safety: '安全性',
    defensiveEnd: 'ディフェンスエンド',
    runningBackHalfback: 'ランニングバック(ハーフバック)',
    runningBackFullback: 'ランニングバック（フルバック）'
  },
  baseball: {
    centerFielder: '中堅手',
    pitcher: '投手',
    catcher: 'キャッチャー',
    baseman: 'ベースマン',
    shortstop: '遊撃手',
    leftFielder: '左翼手',
    rightFielder: '右翼手',
    firstBaseman: '一塁手',
    secondBaseman: '二塁手',
    thirdBaseman: '三塁手',
    designatedHitter: '指名打者'
  },
  basketball: {
    pointGuard: 'ポイントガード',
    shootingGuard: 'シューティングガード',
    smallForward: 'スモールフォワード',
    powerForward: 'パワーフォワード',
    center: 'センター',
    comboGuard: 'コンボガード',
    wingGuard: 'ウイングガード',
    pointForward: 'ポイントフォワード',
    comboForward: 'コンボフォワード'
  },
  cricket: {
    captain: 'キャプテン',
    wicketkeeper: 'ウィケットキーパー',
    slip: 'スリップ',
    gully: 'ガリー',
    point: 'ポイント',
    cover: 'カバー',
    thirdMan: '三塁手',
    fineLeg: 'ファインレッグ',
    midWicket: 'ミッドウィケット',
    midOff: 'ミッドオフ',
    squareLeg: 'スクエアレッグ'
  },
  soccer: {
    goalkeeper: 'ゴールキーパー',
    striker: 'ストライカー',
    centerbackStopper: 'センターバック（ストッパー）',
    centerbackSweeper: 'センターバック（スイーパー）',
    centerbackQuarterBack: 'センターバック（クォーターバック）',
    rightFullback: '右サイドバック',
    leftFullback: '左サイドバック',
    centerForward: 'センターフォワード',
    wingers: 'ウイングス',
    leftMid: '左サイドバック',
    wideMid: 'サイドハーフ',
    rightMid: '右翼手',
    centerMid: '中堅手',
    attackingMid: '攻撃的ミッドフィールダー',
    defensiveMid: '守備的ミッドフィールダー',
    defensiveMidBallWinner: '守備的ミッドフィールダー(ボール奪取型)',
    defensiveMidDeepLyingPlaymaker: '守備的ミッドフィルダー（深追いするプレーメーカー）',
    boxToBoxMid: 'ミッドフィルダー',
    wingback: 'ウイング/ウイングバック',
    false9: '偽の9番',
    raumdeuter: 'スペースリーダー',
    forward: 'フォワード'
  },
  tennis: {
    oneUp: 'ワンアップ',
    oneBack: 'ワンバック'
  },
  handball: {
    goalkeeper: 'ゴールキーパー',
    leftBack: '左バック',
    centerBack: 'センターバック/センター',
    rightBack: '右バック',
    leftWinger: '左ウイング',
    centerForward: 'センターフォワード/ピボット/サークルランナー',
    rightWinger: '右ウイング',
    farRight: 'ファーライト',
    halfRight: 'ハーフライト',
    backCenter: 'バックセンター',
    frontCenter: 'フロントセンター'
  },
  iceHockey: {
    leftDefenseman: '左ディフェンスマン',
    goaltender: 'ゴールテンダー／ゴールキーパー',
    rightDefenseman: '右ディフェンスマン',
    leftWinger: '左ウィンガー',
    center: 'センター',
    rightWinger: '右ウィンガー'
  },
  lacrosse: {
    attackmen: 'アタックマン',
    mid: 'ミッドフィルダー',
    defensemen: 'ディフェンスマン',
    goalkeeper: 'ゴールキーパー'
  },
  polo: {
    lowWingLeftWing: 'ローウィング/レフトウィング',
    lowWingRightWing: 'ローウィング/ライトウィング',
    centerHoleSet: 'センター/ホールセット',
    topWingLeftFlat: 'トップウィング/レフトフラット',
    topWingRightFlat: 'トップウィング/ライトフラット',
    point: 'ポイント',
    cornerPost: 'コーナー/ポスト',
    middleDefense: 'ミドル/ディフェンス',
    topDefense: 'トップディフェンス'
  },
  rowing: {
    coxswain: 'コックス',
    rower: 'ローワー'
  },
  softball: {
    pitcher: '投手',
    catcher: 'キャッチャー',
    firstBaseman: '一塁手',
    secondBaseman: '二塁手',
    shortstop: '遊撃手',
    thirdBaseman: '三塁手',
    leftFielder: '左翼手',
    centerFielder: '中堅手',
    rightFielder: '右翼手'
  },
  rugby: {
    looseheadProp: 'ルースヘッドプロップ',
    hooker: 'フッカー',
    tightheadProp: 'タイトヘッドプロップ',
    lock2ndRow: 'ロック／セカンドロウ',
    blindSideFlanker: 'ブラインドサイドフランカー',
    openSideFlanker: 'オープンサイド型フランカー',
    number8: 'ナンバーエイト',
    scrumHalf: 'スクラムハーフ',
    flyHalf: 'フライハーフ',
    leftWing: 'レフトウィング',
    insideCenter: 'インサイドセンター',
    outsideCenter: 'アウトサイドセンター',
    rightWing: 'ライトウイング',
    fullback: 'フルバック'
  },
  volleyball: {
    setter: 'セッター',
    outsideHitter: 'アウトサイドヒッター',
    middleBlocker: 'ミドルブロッカー',
    libero: 'リベロ',
    oppositeHitter: 'オポジットヒッター'
  },
  stories: {
    subscribeTo: '購読して{{name}}の他のストーリーにアクセスしてください'
  },
  reports: {
    descriptionPlaceholder: '理由を説明してください...',
    reportingPost: '{{name}}の投稿を報告しています',
    reportingShoutout: '{{name}}の叫び声を報告しています',
    reportingStory: '名前}}のストーリーを報告する',
    report: 'レポート'
  },
  error: {
    noNetwork: 'インターネットに接続されていません。',
    somethingWentWrong: 'エラーが発生しました。',
    pleaseTryAgainLater: 'しばらくしてからもう一度お試しください。'
  },
  requestShoutout: {
    discardChanges: '変更を取り消しますか？',
    selectAthlete: 'アスリートを選択',
    newRequest: '新規リクエスト',
    requestAShoutout: 'シャウトアウトをリクエスト',
    itsMine: '私宛です',
    forSomeoneElse: '他の人宛です',
    whatIsYourName: 'あなたのお名前は？',
    introduction: '自己紹介する',
    selectOcassion: 'シーン/理由を選択',
    birthday: '誕生日',
    anniversary: '記念日',
    motivational: 'モチベーションアップ',
    mentorship: 'アドバイス希望',
    gender: '性別',
    addInstruction: 'ご要望を追加（言ってもらいたいこと）',
    deliveryInfo: 'お届け情報',
    videoDelivered: '動画は{{day}}日で届きます。',
    requestSent: 'リクエストが送信されました！',
    requestConfirmation:
      '{{athlete}}にあなたのシャウトアウトリクエストを送信しました。リクエストは{{day}}日以内に対応されます。',
    whoThisFor: 'どなたに宛てたものですか？',
    standard: '標準 ({{price}})',
    bookNow: '予約する',
    backToShoutout: 'シャウトアウト一覧に戻る',
    maximum18Chars: '18文字まで',
    maximum200Chars: '200文字まで',
    youCanAdd18Chars: '18文字まで入力できます',
    youCanAdd200Chars: '200文字まで入力できます'
  },
  yourRequests: {
    view: '見る',
    yourRequests: 'あなたのリクエスト',
    myShoutoutRequests: '私のシャウトアウトリクエスト',
    shoutoutRequestsFromFans: 'Shoutout Requests from Fans',
    face2faceRequests: 'Face2faceのリクエスト',
    all: 'すべて',
    pending: '保留中',
    completed: '完了',
    unfulfilled: '期限切れ',
    fromAthletes: 'アスリートから',
    fromFans: 'ファンから',
    dayLeft: 'あと{{dayLeft}} 日',
    daysLeft: 'あと{{dayLeft}} 日',
    fulfilledOn: '{{date}} に完了',
    unfulfilledOn: '{{date}} に期限が切れました',
    decline: '辞退',
    startRecording: '録画を開始する',
    record: '録画',
    tapForRecording: 'タップして録画',
    send: '送信',
    completeTheRequest: 'リクエストを完了する',
    discardChanges: '変更を取り消しますか？',
    confirm: '確定',
    cancel: 'キャンセル',
    awesome: 'すばらしい！',
    shoutoutSuccessfullySent: 'あなたのシャウトアウトが送信されました！',
    declineTheRequest: 'リクエストを断る',
    busyConsiderToProfit:
      'ご多忙とは存じますが、次のファンリクエストではぜひあなたのブランド価値の収益化をご検討ください。',
    busyConsiderToProfitWordBreak:
      'ご多忙とは存じますが、次のファンリクエストではぜひあなたのブランド価値の収益化をご検討\nください。'
  },
  shoutoutsVideoGallery: {
    fromMe: 'ご自身から',
    fromFellowAthletes: '仲間のアスリートから',
    for: '{{name}} へ'
  },
  letsChatSports: {
    startChat: 'Start Chat',
    writeTopic: 'Write a topic'
  },
  sorting: {
    mostRecent: '最新',
    oldest: '最古'
  },
  callToAction: {
    follow: 'つながろう！ そして最新情報をゲット',
    subscribe: 'コンテンツ以上の価値を！月額サブスクで特典をゲット！',
    requestShoutout: 'あなたの名前、私の声――今すぐシャウトアウトをゲットしよう！',
    sendShoutout: '盛り上がろう！ここにシャウトアウトを投稿！',
    face2face: '一対一で話したいですか？ライブでお話ししましょう！',
    adPlayaz: '一緒にブランドを成長させよう！',
    fancamLive:
      'ファンカムリアクト - スポットライトを浴びて、ゲームデーの熱気から日常の情熱まで、ファンとともにあなたのリアクトの瞬間をシェアしよう。',
    fancamChallenge:
      '瞬間を切り取ろう。写真や動画を投稿して、アップロードするたびにポイントを獲得し、ランキングを駆け上がれ。',
    playToWinPoll: 'あなたの声が決める。試合のMVPを選んで、お気に入りの選手をトップへ導こう。',
    playToWinQuickQuiz: '知識を試そう。クイズに挑戦して、あなたのファンIQを証明しよう。',
    predictScore: '予想を立てよう。試合が始まる前にハーフタイムと最終スコアを確定させよう。',

    sendAShoutout: 'シャウトアウトを送る',
    sendShoutoutTitle: '{{name}}へ応援メッセージを送ろう。',
    sendShoutoutSubtitle: 'あなたのメッセージを{{name}}に届けよう',
    authenticatedUserMsg: 'おかえりなさい、{{name}}さん！',
    start: 'はじめる',
    createFanProfile: 'ファンプロフィールを作成',
    signInToFanProfile: 'ファンプロフィールにログイン',
    toSendYourShoutout: 'Shout-Outを送信しましょう。',
    yourShoutoutTo: ' Shoutoutを選択するか、オリジナルメッセージを入力する',
    writeYourOwnMessage: 'メッセージを入力',
    typeMessageOrEmojis: 'メッセージを入力、または絵文字を追加…',
    addPhotoOrVideo: '写真または動画を追加（任意）',
    postShoutout: 'Shoutoutを投稿',
    shoutoutSentTitle: 'Shoutoutを送信しました！',
    shoutoutSentPoints: '<highlight>{{points}}ポイント</highlight>獲得しました！',
    shoutoutSentSubtitle: '{{name}}へ応援メッセージを送ろう。',
    fullTimePredictionAvaialbleInApp: 'Full-timeスコア予想はアプリで参加できます。',
    continueInApp: 'アプリでFull-timeのスコアを予想して、さらに他のゲームを楽しもう！',
    continueInAppShort: 'アプリで続ける',
    predictFullTimeInApp: 'アプリでFull-timeのスコアを予想する',
    noThanksContinueToChannel: ' いいえ、{{name}}チャンネルへ進む',
    presetsLockedMessage:
      '<highlight>{{name}}</highlight>への応援ありがとうございます！カスタムShoutoutはいつでも送信できます。新しい定型メッセージは<highlight>{{time}}</highlight>後に利用可能になりますので、ぜひまたチェックしてください。',
    presetsLockedMessageNoTime:
      '<highlight>{{name}}</highlight>への応援ありがとうございます！カスタムShoutoutはいつでも送信できます。新しい定型メッセージは近日中に利用可能になりますので、ぜひまたチェックしてください。',
    timeInHours: '{{count}}時間',
    timeInDays: '{{count}}日',
    presetUnavailable:
      'そのプリセットメッセージは利用できなくなりました。別のメッセージを選ぶか、自分のメッセージを書いてください。',

    predictHalfTime: 'Half-Timeのスコアを予想しよう：',
    submitPrediction: '予想を送信',
    yourPick: 'あなたの予想',
    yourVoteIs: 'あなたのHalf-timeスコア予測は{{score}} ',
    halfTimePredictionsClosed: 'Half-Time予想の受付は終了しました。',
    noPredictionsYet: 'まだ予想はありません。',
    confirmHalfTimePrediction: 'Half-Timeのスコア予想を送信しますか？',
    yesSubmit: 'はい、送信する',
    predictionVoteFailed: '予想を送信できませんでした。もう一度お試しください。',
    earnMorePointsByPrediction: 'スコア予想に参加して、さらにポイントを獲得しましょう。',
    predictionPointsEarned: '<highlight>{{points}}ポイント</highlight>を獲得しました！',

    actionFollow: 'つながろう！',
    actionSubscribe: 'プレミアム特典をアンロック！',
    actionRequestShoutout: 'シャウトアウトをゲットしよう！',
    actionSendShoutout: 'あなたのメッセージを届けよう',
    actionF2F: 'ライブで話そう！',
    actionAdPlayaz: 'ブランドを強化しよう！',

    actionFancamLive: '瞬間をシェアしよう',
    actionFancamChallenge: 'チャレンジに参加！',
    actionPlayToWinPoll: 'あなたの選択を',
    actionPlayToWinQuickQuiz: 'ファンIQを試そう',
    actionPredictScore: 'スコアを予想しよう',

    startFancamLive: 'Fancam Reactを開始',
    submitPhotoVideo: '写真/動画を投稿',
    voteNow: '今すぐ投票',
    takeTheQuiz: 'クイズに挑戦',
    predictScoreBtn: 'スコアを予想',
    seeRewards: '特典を見る',
    actionRewards: 'このチームの特典をチェック',

    warning: '警告:',
    mediaChange: 'メディアの閲覧範囲が「全員」',
    anyone: 'Anyone',
    warningMediaChange: '警告：メディアの閲覧範囲が「全員」に変更されます',

    chooseEngagement: '最初にエンゲージメントを選んでください。',
    linkCopied: 'リンクがクリップボードにコピーされました。',
    selectImage: 'Instagramにシェアする前に画像を選択または追加してください。'
  },
  updateApp: {
    newVersionAvailable: '新しいバージョンが利用可能です',
    pleaseUpdate: 'Playaz4Playazを継続してご利用いただくには、アプリをアップデートしてください。',
    updateNow: '更新する'
  },
  paymentMethod: {
    selectPaymentMethod: '支払い方法を選択',
    choosePreferredMethod: 'ご希望のカード支払い方法を選択してください',
    cardPaymentOptions: 'カード支払いのオプション',
    komojuDescription: '高速で安全なカード決済',
    stripeDescription: '安全で信頼性の高いグローバル決済',
    stripeCardDescription: 'Visa、Mastercard、AMEXで安全にお支払い',
    applePayDescription: 'Apple Payでスピーディーに決済',
    googlePayDescription: 'Google Payでスピーディーに決済',
    linkDescription: 'Stripe Linkでワンクリック決済',
    selectedPlan: '選択されたプラン',
    defaultPlanName: 'プレミアムサブスクリプション',
    month: '月',
    year: '年',
    featureUnlimitedAccess: '無制限の独占アクセス',
    featurePrioritySupport: '優先ファンサポート',
    featureExclusiveContent: '独占的なアスリートコンテンツ',
    processing: '処理中...',
    payNow: '今すぐ支払う',
    noPlanSelected: 'プランが選択されていません',
    securePayment: '安全なSSL暗号化決済',
    paymentMethods: '支払い方法',
    planNotFound: 'プランが見つかりません',
    planNotFoundDesc: 'お探しのサブスクリプションプランは存在しないか、削除されました。',
    serverError: 'エラーが発生しました',
    serverErrorDesc: 'プランの詳細を読み込めませんでした。後でもう一度お試しください。',
    backToPlans: 'プラン一覧に戻る',
    cancelTitle: 'お支払いをキャンセルしますか？',
    cancelDescription: 'キャンセルしてもよろしいですか？現在の選択内容が失われます。',
    confirmPaymentTitle: 'お支払いの確認',
    confirmPaymentDescription: 'この支払いを進めてもよろしいですか？',
    whatsIncluded: '含まれる内容：',
    total: '合計',
    subscriptionSummary: 'サブスクリプション概要',
    pay: 'お支払い',
    oneTimePaymentNote: 'これは一回限りのお支払いです。再度請求されることはありません。'
  },
  subscription: {
    paymentSuccessful: 'お支払い完了！',
    successMessage: 'ご登録ありがとうございます。アカウントがアップグレードされました。',
    paymentProcessing: 'お支払い処理中',
    processingMessage: 'お支払いを受け付けました。現在処理中です。しばらくお待ちください。',
    processing: '処理中',
    fetchInfoError: 'サブスクリプション情報を読み込めませんでした。',
    team: 'チーム',
    planTier: 'プランティア',
    status: 'ステータス',
    nextBillingDate: '次回請求日',
    manageSubscription: 'サブスクリプション管理',
    paymentFailed: 'お支払いに失敗しました',
    failureReason: 'お支払いを処理できませんでした。カード情報を確認して、もう一度お試しください。',
    tryAgain: '再試行',
    contactSupport: 'サポートに問い合わせ',
    alreadySubscribed: 'すでにこのチームを購読しています。',
    hero: {
      tagline: 'インナーサークルに参加しよう',
      title: 'プレミアムアクセス',
      subtitle: 'FC東京を今までにない形で楽しもう',
      subtitle_prefix: 'アンロック',
      subtitle_suffix: '今までにない形で',
      priceDisclaimer: '注：為替レートにより、実際の決済ページでの価格は多少異なる場合があります。'
    },
    studioName: 'P4P FAN PLAY STUDIOS 提供',
    subscribeButton: '購読 - {{price}}{{currencySign}}/月',
    subscribeButtonYearly: '購読 - {{price}}{{currencySign}}/年',
    upgradePlan: 'プランをアップグレード',
    downgradeNotAllowed: 'ダウングレードは許可されていません',
    continueFreePlan: '無料プランで継続',
    followToSubscribe: 'このチームをフォローして購読',
    maybeLater: '後で',
    supportPaymentVia: '支払い方法',
    payWith: '',
    payWithSuffix: 'でお支払い',
    creditCards: 'クレジットカード',
    applePay: 'Apple Pay',
    googlePay: 'Google Pay',
    upgradeSuccessful: 'サブスクリプションのアップグレードが完了しました！',
    upgradeFailed: '問題が発生しました。もう一度お試しください。',
    checkingStatus: 'サブスクリプションステータスを確認中...',
    subscriptionDetails: 'サブスクリプション詳細',
    currentSubscription: '現在のサブスクリプション',
    changePlan: 'プランを変更',
    upgradeYourPlan: 'サブスクリプションを変更',
    currentPlan: '現在',
    newPlan: '新しいプラン',
    switchToAnnualBilling: '年額請求へ変更する',
    moveToPlan: '{{plan}} へ移行する',
    prorationNotice: '日割り計算適用',
    prorationExplanation: '現在のプランの未使用期間がクレジットされ、差額が請求されます。',
    confirmUpgrade: '変更を確認',
    manageBilling: '請求管理',
    accessUntil: 'アクセス期限',
    cancelledGracePeriod: {
      title: 'サブスクリプションがキャンセルされました',
      message:
        'サブスクリプションはキャンセルされましたが、現在の請求期間が終了するまでは引き続きご利用いただけます。この期間中はプランの変更はできません。'
    },
    noPlanChange: {
      title: 'プラン変更不可',
      message: '現在、年間サブスクリプションのプラン変更はご利用いただけません。'
    },
    providerMismatch: {
      title: 'プランを変更できません',
      message:
        '現在のサブスクリプションは別の決済プロバイダーで購入されました。新しいプランを購入する前に、現在のサブスクリプションをキャンセルしてください。'
    },
    error: {
      title: '問題が発生しました',
      message: 'サブスクリプションプランを読み込めませんでした。後でもう一度お試しください。',
      tryAgain: '再試行',
      goBack: '戻る'
    },
    paywall: {
      eyebrow: 'メンバーシップ',
      title: 'P4P ファンプレイスタジオ',
      subtitle: 'レベルを選んで、すべての試合、メッセージ、瞬間をもっと特別に。',
      free: '無料',
      switchToAnnual: '年額プランへ変更する',
      currentPlan: '現在のプラン',
      multiplier: 'ポイント倍率 {{multiplier}}倍',
      pricePerMonth: '月額 {{price}}',
      monthly: '月額',
      annual: '年額',
      perMonthShort: '{{price}}/月',
      perYearShort: '{{price}}/年',
      bestValue: 'おすすめ',
      planTitles: {
        basic: '無料プラン',
        fanchat: 'FanChatのみ',
        fanchat_tiri: 'FanChat + TIRIパック',
        active: 'アクティブサポーター',
        elite: 'エリートサポーター'
      },
      cta: {
        fanchat: 'FanChatを選択',
        fanchat_tiri: 'FanChat + TIRIパックで続ける',
        active: 'アクティブにアップグレード',
        elite: 'エリートにアップグレード'
      },
      payment: {
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        card: 'カード'
      },
      disclosure: '登録を確定する前に、すべての詳細をご確認いただけます。',
      continueFree: '無料プランで続ける',
      restore: 'メンバーシップを復元',
      restoring: '確認中…',
      restoreFound: 'メンバーシップは有効です。',
      restoreNotFound: 'このアカウントのメンバーシップは見つかりませんでした。',
      restoreError: 'メンバーシップの確認に失敗しました。もう一度お試しください。',
      terms: '利用規約',
      privacy: 'プライバシー'
    },
    plans: {
      free: '無料',
      pricePerMonth: '{{currencySign}}{{price}}/月',
      pricePerYear: '{{currencySign}}{{price}}/年',
      monthlyOnly: '(月額のみ)',
      bestValue: 'ベストバリュー',
      basicSupporter: 'ベーシックサポーター',
      activeSupporter: 'アクティブサポーター',
      eliteSupporter: 'エリートサポーター'
    },
    features: {
      // Tier-specific copy from the Japanese design. Lookup order: features.<tier>.<key>, features.<key>, stored title.
      basic: {
        'live-leaderboard-and-fan-perk-access': 'ランキング（毎試合リセット）',
        'play-to-win-predictions-and-quiz': '予想機能',
        'fan-rewards-and-perks': 'ファン特典＆リワード',
        'standard-fancam': '写真・動画を無制限アップロード',
        'fanchat-read-only': 'FanChat（閲覧のみ）'
      },
      fanchat: {
        fanchat_write: 'リアルタイムで投稿・返信・リアクション'
      },
      fanchat_tiri: {
        'fanchat-tiri-pack': 'FanChat + TIRI－ファンの瞬間をタグ付け・評価'
      },
      active: {
        'basic-supporter-plus': '無料プラン + FanChat + TIRIパックの全機能'
      },
      elite: {
        'active-supporter-plus': 'アクティブの全機能'
      },
      'live-leaderboard-and-fan-perk-access': 'ライブリーダーボード & ファン特典アクセス',
      'play-to-win-predictions-and-quiz': 'プレイして勝つ：予想 & クイズ',
      'standard-fancam': 'スタンダードファンカム',
      'shoutouts-to-team-2-per-week': 'チームへのシャウト：週2回',
      '1.0xpoints-earned': '獲得ポイント {{multiplier}}倍',
      'basic-supporter-plus': 'ベーシックサポータープラス',
      'standard-ar-filters': 'スタンダードARフィルター',
      'premium-ar-filters': '+ プレミアムARフィルター',
      'unlimited-shoutouts': '無制限シャウト',
      'p4p-ai-replay-analysis': 'P4P AIリプレイ分析',
      'fanchat-access-and-content': 'FanChatアクセス',
      '1.25xpoints-earned': '獲得ポイント {{multiplier}}倍',
      'active-supporter-plus': 'アクティブサポータープラス',
      'fanchat-access-and-exclusive-drops': 'FanChatアクセス + 限定ドロップ',
      '1.5xpoints-earned': '獲得ポイント {{multiplier}}倍',
      descriptions: {
        'live-leaderboard-and-fan-perk-access':
          '試合中のライブリーダーボードとファン特典へのアクセス',
        'play-to-win-predictions-and-quiz':
          '試合予想とクイズに参加してポイントを獲得し、リーダーボードを登ろう',
        'standard-fancam': '試合中のスタンダードファンカム機能へのアクセス',
        'shoutouts-to-team-2-per-week': 'SNSチャンネルで週2回チームへのシャウトアウトを受け取れる',
        '1.0xpoints-earned': 'すべての活動で{{multiplier}}倍のレートでポイントを獲得',
        'basic-supporter-plus': 'ベーシックサポーターの全機能に加え、追加特典',
        'standard-ar-filters': 'ファンカム写真用のスタンダードARフィルターへのアクセス',
        'premium-ar-filters': 'ファンカム写真・動画用のプレミアムARフィルターへの限定アクセス',
        'unlimited-shoutouts': 'SNSチャンネルでのチームへの無制限シャウトアウト',
        'p4p-ai-replay-analysis': 'AI搭載のリプレイ分析で試合予想とパフォーマンスを振り返り',
        'fanchat-access-and-content': '他のファンと交流できるFanChatへの限定アクセス',
        '1.25xpoints-earned':
          'すべての活動で{{multiplier}}倍のレートでポイントを獲得し、リーダーボードを素早く登ろう',
        'active-supporter-plus': 'アクティブサポーターの全機能に加え、限定エリート特典',
        'fanchat-access-and-exclusive-drops':
          'FanChatへの限定アクセスで、選手・インフルエンサーとの特別コンテンツドロップや交流',
        '1.5xpoints-earned':
          'すべての活動で{{multiplier}}倍のレートでポイントを獲得し、リーダーボードトップを目指せる最高チャンス'
      }
    },
    admin: {
      title: 'サブスクリプションプラン',
      syncAll: 'すべて同期',
      syncing: '同期中...',
      syncPlan: '同期',
      syncingPlan: '同期中...',
      syncPlanDone: 'プランは Stripe と同期済みです。',
      search: {
        placeholder: 'チームを検索',
        clear: '検索をクリア',
        noResultsTitle: '「{{query}}」に一致するチームはありません',
        noResultsMessage: 'スペルを確認するか、短い名前でお試しください。'
      },
      createPlan: 'プランを作成',
      unknownTeam: '不明なチーム',
      stats: {
        synced: '同期済み',
        pending: '保留中',
        error: 'エラー',
        plan: 'プラン',
        plan_plural: 'プラン'
      },
      empty: {
        title: 'サブスクリプションプランはまだありません',
        message: '最初のサブスクリプションプランを作成して、国ごとの価格管理を開始しましょう。'
      },
      table: {
        country: '国',
        title: 'プラン名',
        monthly: '月額',
        yearly: '年額',
        currency: '通貨',
        sync: '同期',
        status: 'ステータス'
      },
      status: {
        active: 'アクティブ',
        inactive: '非アクティブ',
        synced: '同期済み',
        pending: '保留中',
        error: 'エラー'
      },
      filters: {
        allCountries: 'すべての国',
        allStatus: 'すべてのステータス'
      },
      tabs: { plans: 'プラン', campaigns: 'キャンペーン' },
      campaigns: {
        createButton: 'キャンペーンを作成',
        empty: {
          title: 'キャンペーンはまだありません',
          message: '作成すると、一定期間だけ有料機能を開放できます。'
        },
        allTeams: 'すべてのチーム',
        jstHint: '時刻は日本時間（UTC+9）です。',
        lockedHint: '実施中のキャンペーンは名前と終了時刻のみ変更できます。',
        endedHint: 'このキャンペーンは終了しました。再度実施するには新しく作成してください。',
        endNow: '今すぐ終了',
        endConfirmHeading: 'このキャンペーンを今すぐ終了しますか？',
        endConfirmText: 'ユーザーの無料アクセスはすぐに終了します。',
        conflict: {
          title: 'この期間は別のキャンペーンと重複しています。',
          allTeams: '全チーム'
        },
        status: { scheduled: '予定', active: '実施中', ended: '終了' },
        column: { name: '名前', status: 'ステータス', features: '機能', teams: 'チーム', starts: '開始', ends: '終了' },
        feature: { fanchat_write: 'FanChat', shoutout_unlimited: 'シャウトアウト', tiri_tag_it: 'TIRI Tag IT' },
        panel: { createTitle: 'キャンペーンを作成', editTitle: 'キャンペーンを編集', viewTitle: 'キャンペーンの詳細' },
        field: {
          name: '名前',
          features: '機能',
          teams: 'チーム',
          allTeams: 'すべてのチーム',
          startsAt: '開始（JST）',
          endsAt: '終了（JST）'
        },
        button: { create: 'キャンペーンを作成', save: '変更を保存', saving: '保存中…' },
        success: { created: 'キャンペーンを作成しました', saved: 'キャンペーンを保存しました', ended: 'キャンペーンを終了しました' },
        error: {
          nameRequired: '名前を入力してください。',
          featuresRequired: '機能を1つ以上選択してください。',
          teamsRequired: 'チームを選択するか、すべてのチームを選んでください。',
          startRequired: '開始時刻を入力してください。',
          endRequired: '終了時刻を入力してください。',
          endAfterStart: '終了時刻は開始時刻より後である必要があります。'
        }
      },
      panel: {
        createTitle: 'サブスクリプションプランを作成',
        editTitle: 'サブスクリプションプランを編集',
        featuresAccessHint: 'FanChat・シャウトアウト・TIRI Tag IT のスイッチはアクセス権限を制御します。オフにするとこのプランでは利用できなくなります。',
        section: {
          details: 'プランの詳細',
          pricing: '価格設定',
          features: '機能',
          featuresToggle: '機能（有効/無効の切り替え）',
          integration: '統合ステータス'
        },
        field: {
          country: '国',
          selectCountry: '国を選択してください',
          team: 'チーム',
          selectTeam: 'チームを選択...',
          loadingTeams: 'チームを読み込み中...',
          tier: 'ティア',
          selectTier: 'ティアを選択...',
          loadingTiers: 'ティアを読み込み中...',
          autoDetected: 'チームから自動検出',
          changeTeam: 'チームを変更',
          title: 'プラン名',
          titlePlaceholder: '例：アクティブサポーター',
          badge: 'バッジ',
          badgePlaceholder: '例：VIP',
          description: '説明',
          descriptionPlaceholder: '例：標準のサブスクリプション層',
          monthly: '月額',
          monthlyDiscount: '月額割引率 %',
          yearly: '年額',
          yearlyDiscount: '年額割引率 %',
          basicTierPriceNote: 'ベーシックプランは無料です — 価格は0に固定されます',
          planActive: 'プランを有効にする',
          planActiveDesc: '無効なプランはユーザーに表示されません',
          featureTitle: 'タイトル',
          featureTitlePlaceholder: '機能のタイトル',
          featureKey: 'キー',
          featureDesc: '説明',
          featureDescPlaceholder: '機能の説明',
          stripeProductId: 'Stripe プロダクトID',
          stripeStatus: 'Stripe：{{status}}'
        },
        button: {
          addFeature: '機能を追加',
          save: '保存',
          saving: '保存中...',
          update: 'プランを更新',
          create: 'プランを作成'
        },
        error: {
          countryRequired: '国は必須です',
          teamRequired: 'チームは必須です',
          stripeRequired: 'プランを作成する前に、チームはStripeアカウントを連携する必要があります',
          profitSplitTotal: 'P4P + チーム + VATの合計は100%でなければなりません（現在{{total}}%）',
          tierRequired: 'ティアは必須です',
          titleRequired: 'プラン名は必須です',
          priceRequired: '少なくとも1つの価格が必要です',
          featureRequired: '少なくとも1つの機能が必要です',
          featureFieldsRequired: '機能のタイトルとキーは必須です'
        },
        stripeStatus: {
          checking: 'Stripeのステータスを確認中…',
          connected: 'Stripe連携済み',
          connectedHint: '— 収益分配が適用されます',
          notConnected: 'Stripe未連携',
          notConnectedHint: '— チームは分配を受けるためにStripeを連携してください'
        },
        success: {
          updated: 'プランを更新しました',
          created: 'プランを作成しました'
        }
      }
    }
  },
  subscriptions: {
    admin: {
      title: 'サブスクリプション概要',
      tabs: {
        overview: '概要',
        mrr: 'MRR',
        churn: '解約率',
        subscribers: '購読者',
        history: '履歴'
      },
      overview: {
        total: '合計購読者数',
        paymentMethods: {
          title: '支払い方法',
          byProvider: 'プロバイダー別',
          byBrand: 'タイプ/ブランド別',
          empty:
            'まだアクティブな購読者はいません。購読者が登録されると、支払い方法のデータがここに表示されます。'
        },
        mrr: {
          title: '月次継続収益',
          subtitle: '通貨ごとの詳細な収益表示（国別・プラン別）',
          currencyCount: '通貨',
          byCountry: '国別',
          byPlan: 'プラン別',
          byTeam: 'チーム別',
          monthlyPlans: '月額プラン',
          yearlyPlans: '年額プラン',
          plan: 'プラン',
          team: 'チーム',
          country: '国',
          countryCode: '国コード',
          currency: '通貨',
          totalMrr: 'MRR合計',
          subscribers: '購読者数',
          monthly: '/ 月',
          empty:
            'まだアクティブなサブスクリプションはありません。サブスクリプションが有効になると、MRR指標がここに表示されます。'
        },
        churn: {
          title: '解約率',
          subtitle: '期間内のキャンセル数 / アクティブ数',
          period: '期間',
          periods: {
            '30d': '過去30日',
            '90d': '過去90日',
            '1y': '過去1年',
            all: '全期間'
          },
          churnRate: '解約率',
          cancelled: 'キャンセル',
          activeDuringPeriod: '期間内のアクティブ数',
          na: 'N/A',
          byCountry: '国別',
          byPlan: 'プラン別',
          byTeam: 'チーム別',
          country: '国',
          countryCode: '国コード',
          plan: 'プラン',
          teamName: 'チーム名',
          cancellations: 'キャンセル数',
          empty: 'この期間の解約データはありません。',
          allTimeNote: '全期間の解約率は計算されません。'
        },
        renewals: {
          title: '更新成功 / 失敗',
          periods: {
            '30d': '過去30日',
            '90d': '過去90日',
            '1y': '過去1年',
            all: '全期間'
          },
          successes: '成功',
          failures: '失敗',
          successRate: '成功率',
          provider: 'プロバイダー',
          empty: 'この期間の更新データはありません。'
        },
        subscriberCount: {
          title: '購読者ステータス',
          empty: '購読者データがありません。',
          group: {
            growthRetention: '成長と継続',
            conversionPipeline: 'コンバージョンパイプライン',
            churnRiskExposure: '解約とリスクエクスポージャー',
            churned: '解約済み'
          },
          initiated: '開始済み',
          processing: '処理中',
          success: '成功',
          failed: '失敗',
          pending: '保留中',
          active: 'アクティブ',
          retrying: '再試行中',
          suspended: '停止中',
          cancelled: 'キャンセル済み',
          deleted: '削除済み'
        }
      },
      revenueSplit: {
        title: '収益分配レポート',
        filters: {
          startDate: '開始日',
          endDate: '終了日',
          countries: '国',
          selectCountries: '国を選択',
          selectedCountries: '{{count}}件選択',
          team: 'チーム',
          allTeams: 'すべてのチーム',
          loadingTeams: 'チームを読み込み中...',
          interval: '課金間隔',
          all: 'すべて',
          monthly: '月額',
          yearly: '年額',
          exportCsv: 'CSVをエクスポート',
          downloading: 'ダウンロード中...'
        },
        currencySection: '{{currency}} セクション',
        table: {
          team: 'チーム',
          country: '国',
          currency: '通貨',
          grossRevenue: '総売上',
          splitVisual: '分配',
          p4pPercent: 'P4P % (加重)',
          p4pAmount: 'P4P 金額',
          teamPercent: 'チーム % (加重)',
          teamAmount: 'チーム金額',
          vatPercent: 'VAT % (加重)',
          vatAmount: 'VAT 金額',
          plans: 'プラン'
        },
        planTable: {
          plan: 'プラン',
          revenueShare: '売上シェア %',
          p4p: 'P4P %',
          team: 'チーム %',
          vat: 'VAT %',
          consistency: '整合性'
        },
        splitLegend: {
          p4p: 'P4P',
          team: 'チーム',
          vat: 'VAT'
        },
        totals: {
          label: '{{currency}} 合計'
        },
        consistency: {
          ok: '100% 正常',
          warning: '分配を確認'
        },
        manualTransferAudit: {
          title: '手動送金監査',
          tab: {
            revenueSplit: '収益分配',
            manualAudit: '手動送金監査'
          },
          filters: {
            status: 'ステータス',
            searchPlaceholder: 'チーム名で検索...'
          },
          status: {
            pending: '保留中',
            reconciled: '照合済み',
            not_required: '不要'
          },
          skipReason: {
            no_profit_split: '利益分配なし',
            no_connected_account: '接続アカウントなし',
            cross_region: 'クロスリージョン'
          },
          table: {
            occurredAt: '発生日',
            interval: '間隔',
            manualDue: '手動送金額',
            reconciledBy: '照合者',
            reconciledAt: '照合日',
            note: 'メモ',
            skipReason: 'スキップ理由',
            actions: '操作'
          },
          reconcile: {
            action: '照合する',
            markPending: '保留に戻す',
            by: '照合者',
            note: 'メモ（任意）',
            confirm: '確認',
            cancel: 'キャンセル',
            notePlaceholder: '例: 2024-03-01 に銀行振込で支払い済み'
          },
          totals: {
            outstanding: '未払い',
            reconciled: '照合済み'
          },
          pagination: {
            showing: '{{from}}〜{{to}}件 / 全{{total}}件を表示'
          }
        },
        empty: '選択した条件に一致するデータがありません。',
        error: '収益分配レポートの読み込みに失敗しました。'
      },
      subscribers: {
        subscriber: '購読者',
        team: 'チーム',
        plan: 'プラン',
        status: 'ステータス',
        provider: 'プロバイダー',
        amount: '金額',
        refund: {
          title: '返金リクエスト',
          requestId: '返金リクエストID',
          amount: '金額',
          provider: 'プロバイダー',
          userNote: 'ユーザーメモ',
          requested: '申請日',
          updated: '更新日',
          providerPaymentId: 'プロバイダー支払いID',
          approvalReason: '承認メモ',
          rejectionReason: '却下理由',
          providerRefundId: 'プロバイダー返金ID',
          processedBy: '処理者',
          subscriptionId: 'サブスクリプションID',
          providerSubId: 'プロバイダーサブスクID',
          adminMessagePlaceholder: '管理者メッセージ（任意）',
          approve: '返金を承認',
          reject: '却下',
          badge: '返金申請中'
        },
        searchPlaceholder: '名前、ユーザー名、またはメールで検索...',
        empty: '購読者が見つかりません。',
        emptySearch: '検索に一致する購読者が見つかりません。',
        endOfList: 'リストの最後です',
        error: '購読者の読み込みに失敗しました。もう一度お試しください。',
        detail: {
          subscriptionDetails: 'サブスクリプション詳細',
          eventTimeline: 'イベントタイムライン',
          eventsCountOne: '{{count}} 件のイベント',
          eventsCountOther: '{{count}} 件のイベント',
          noEvents: '請求イベントは記録されていません。',
          started: '開始日',
          currentPeriodStart: '現在の期間開始',
          currentPeriodEnd: '現在の期間終了',
          nextRenewal: '次回更新',
          interval: '請求間隔',
          renewals: '更新回数',
          failures: '失敗',
          cancelledAt: 'キャンセル日',
          scheduledCancel: 'キャンセル予定',
          endedAt: '終了日',
          reason: '理由',
          created: '作成日',
          paymentMethod: '支払い方法',
          cardBrand: 'ブランド',
          cardLast4: 'カード番号',
          cardExpiry: '有効期限',
          paymentType: 'タイプ',
          period: '期間',
          expiryShort: '有効期限',
          intervalShort: {
            monthly: '月',
            yearly: '年'
          },
          eventTypes: {
            checkout_initiated: 'チェックアウト開始',
            subscribed: '購読開始',
            renewed: '更新',
            upgraded: 'アップグレード',
            downgraded: 'ダウングレード',
            payment_succeeded: '支払い成功',
            payment_failed: '支払い失敗',
            renewal_failed: '更新失敗',
            cancelled: 'キャンセル',
            suspended: '停止',
            refund_requested: '返金リクエスト',
            refund_approved: '返金承認',
            refund_rejected: '返金却下'
          }
        }
      },
      status: {
        initiated: '開始済み',
        processing: '処理中',
        success: 'アクティブ',
        active: 'アクティブ',
        retrying: '再試行中',
        suspended: '停止中',
        cancelled: 'キャンセル済み',
        failed: '失敗',
        pending: '保留中',
        deleted: '削除済み',
        refunded: '返金済み'
      },
      comingSoon: '近日公開'
    }
  },
  admin: {
    readOnlyField: 'これは読み取り専用の項目です',
    goalRush: {
      tabs: {
        sessions: 'セッション',
        defaults: 'デフォルト',
        overrides: 'オーバーライド'
      },
      team: 'チャンネル',
      groups: {
        session: 'セッションと目標',
        points: 'ポイント',
        others: 'その他'
      },
      rows: {
        gaps: 'ディフェンダーの隙間',
        bonus: 'ネット内のボーナスターゲット'
      },
      fields: {
        sessionDurationSec: 'セッションの長さ',
        targetKicks: 'キック目標',
        targetGoals: 'ゴール目標',
        kickMilestonePoints: 'キックのマイルストーン',
        goalMilestonePoints: 'ゴールのマイルストーン',
        pointsPerKick: 'キック 1 回のポイント',
        pointsPerGoal: 'ゴール 1 回のポイント',
        defenderPatternId: 'ディフェンダーの動き',
        others_gapIntervalSec: '隙間の間隔（秒）',
        others_gapDurationMs: '隙間の長さ（秒）',
        others_minGapWidth: '隙間の最小幅',
        others_bonusIntervalSec: 'ボーナスターゲットの間隔（秒）',
        others_bonusVisibleMs: 'ボーナスターゲットの表示時間（秒）',
        pointsPerBonusHit: 'ボーナスターゲット命中ポイント'
      },
      help: {
        sessionDurationSec: 'リセットまでのセッションの長さ。',
        targetKicks: 'この回数に達するとセッション達成。',
        targetGoals: 'このゴール数に達するとセッション達成。',
        kickMilestonePoints: 'キック目標の達成時に、キックした全ファンに付与。',
        goalMilestonePoints: 'ゴール目標の達成時に、キックした全ファンに付与。',
        pointsPerKick: 'キックごとに付与。',
        pointsPerGoal: 'ゴール時に追加で付与。',
        others_gapIntervalSec: 'ディフェンダーが隙間を作る頻度。',
        others_gapDurationMs: '隙間が開いている時間。',
        others_minGapWidth: 'フィールド幅に対する割合（1 = ピッチ全体）。',
        others_bonusIntervalSec: 'ボーナスターゲットが現れる頻度。',
        others_bonusVisibleMs: 'ボーナスターゲットの表示時間。',
        pointsPerBonusHit: 'ボーナスターゲットに当てたゴールのファンに付与されるポイント。'
      },
      range: '範囲 {{min}}〜{{max}}。',
      durationRange: '1〜60 分、1〜60 時間、または 1〜365 日。',
      patterns: {
        classic: {
          label: 'クラシック',
          description: '20 秒ごとにスイープ・振り子・アークを切り替え。'
        },
        sweep: {
          label: 'スイープ',
          description: '一定の速さで左右に移動。'
        },
        oscillate: {
          label: '振り子',
          description: '端で減速するなめらかな往復。'
        },
        arc: {
          label: 'アーク',
          description: '上下にも動く曲線の軌道。'
        }
      },
      errors: {
        required: '必須です。',
        integer: '整数のみ入力できます。',
        range: '{{min}}〜{{max}} の範囲で入力してください。',
        durationRange: {
          minutes: '1〜{{max}} 分の範囲で入力してください。',
          hours: '1〜{{max}} 時間の範囲で入力してください。',
          days: '1〜{{max}} 日の範囲で入力してください。'
        }
      },
      loading: '読み込み中…',
      save: '変更を保存',
      saving: '保存中…',
      saved: 'GoalRush のルールを保存しました。',
      saveFailed: 'GoalRush のルールを保存できませんでした。',
      cancel: 'キャンセル',
      confirm: '確認',
      applies: {
        session: '変更は次のセッションから適用されます。',
        points: '変更は次のセッションから適用されます。',
        others: '変更は次のセッションから適用されます。'
      },
      defaults: {
        notStarted:
          'このチャンネルではまだ GoalRush が実行されていません。下のデフォルトを保存すると開始され、チームチャンネルにすぐ表示されます。',
        confirmFirstSave:
          'このデフォルトでこのチャンネルの GoalRush を開始しますか？デフォルトセッションが今すぐ始まり、チームチャンネルに表示されます。',
        alwaysOn:
          'このチャンネルではデフォルトの GoalRush が常に実行されます。各セッションは目標に達するか時間切れになると終了し、新しいセッションが始まります。オーバーライドの実行中はデフォルトセッションが一時停止し、時間も止まります。',
        confirmSave:
          'このチャンネルのデフォルト GoalRush を保存しますか？進行中のセッションは現在のルールのまま続き、変更は次のセッションから適用されます。'
      },
      overrides: {
        enable: 'オーバーライドを有効にする',
        on: 'オン',
        off: 'オフ',
        channelOff:
          'このチャンネルの GoalRush はまだ設定されていません。オーバーライドを実行するには、先にデフォルトを保存してください。',
        warning:
          'このオーバーライドを有効にすると、進行中のデフォルトセッションは一時停止し、このセッションがすぐに始まります。オーバーライドが終わるとデフォルトセッションが再開します。',
        confirmEnable:
          'このオーバーライドを有効にしますか？進行中のデフォルトセッションは今すぐ一時停止し、オーバーライドが始まります。',
        confirmDisable:
          'オーバーライドを無効にしますか？進行中の場合は今すぐ終了し、デフォルトセッションが再開します。',
        confirmSave:
          'オーバーライドを保存しますか？進行中の場合は現在のルールのまま続き、変更は次回の開始時から適用されます。'
      },
      sessions: {
        title: 'セッション',
        refresh: '更新',
        more: 'さらに読み込む',
        none: 'まだセッションはありません。ファンが GoalRush を開くと始まります。',
        kind: {
          default: 'デフォルトセッション',
          override: 'オーバーライドセッション'
        },
        status: {
          running: '進行中',
          paused: '一時停止中',
          completed: '達成',
          timeUp: '時間切れ',
          terminated: '終了（管理者）'
        },
        pausedSince: '{{time}} からオーバーライドにより一時停止中',
        liveNow: 'ライブ中',
        previous: '過去のセッション',
        noLimit: '時間制限なし',
        kicks: 'キック / 目標',
        goals: 'ゴール / 目標',
        fans: 'ファン',
        detail: {
          title: 'セッションの詳細',
          progress: '進捗',
          kicks: 'キック',
          goals: 'ゴール',
          endReason: '終了理由',
          endReasons: {
            target_reached: '目標を達成',
            target_not_reached: '時間切れ',
            admin_override: 'オーバーライドにより終了',
            disabled: 'GoalRush がオフになった'
          },
          targetHit: {
            kicks: 'キック目標を達成 · {{time}}',
            goals: 'ゴール目標を達成 · {{time}}'
          },
          rewardPerFan: 'ファン1人あたり +{{value}} pt',
          gameplay: 'ゲームプレイ',
          stats: {
            blocked: 'ブロック',
            nearMiss: 'ニアミス',
            collisions: '衝突',
            rebounds: 'リバウンド',
            bonusHits: 'ボーナスヒット'
          },
          pauses: '一時停止',
          pauseOngoing: '一時停止中',
          rules: '適用されたルール',
          kickCooldown: 'キックのクールダウン',
          gapsSummary: '{{every}}秒ごと、{{open}}開く、最小幅 {{width}}',
          bonusSummary: '{{every}}秒ごと、{{visible}}表示',
          off: 'オフ',
          fans: 'ファン',
          fansTop: 'キック数上位 {{shown}} 人 / 全 {{total}} 人',
          fansNone: 'このセッションに参加したファンはまだいません。',
          fan: 'ファン',
          points: 'ポイント',
          deletedFan: '削除されたユーザー',
          settlement: 'ポイントの支払い',
          settled: '{{time}} にポイントを支払い済み。',
          settlePending: '終了済み — ポイントはまだ支払われていません。',
          settleOnEnd: 'ポイントはセッション終了時に支払われます。'
        }
      },
      noChannel: 'GoalRush のルールを管理するチャンネルを選んでください。'
    },
    nav: {
      users: 'ユーザー',
      teams: 'チーム',
      updates: '更新',
      posts: '投稿',
      products: '商品',
      orders: '注文',
      pricing: '価格',
      games: 'ゲーム',
      generalSettings: '一般設定',
      shoutouts: 'シャウトアウト',
      subscription: 'サブスクリプション',
      revenueSplit: '収益分配レポート',
      auditLogs: '監査ログ',
      stripeRequests: 'Stripeリクエスト',
      webhookLogs: 'Webhookログ',
      quickQuiz: 'クイッククイズ',
      liveStatsEngagement: 'ライブスタッツエンゲージメント',
      tiri: 'TIRI',
      insights: 'インサイト',
      email: 'メールマネージャー',
      goalRush: 'GoalRush'
    },
    auditLogs: {
      title: '監査ログ',
      allActors: 'すべての操作者',
      allTargets: 'すべての対象',
      allActions: 'すべてのアクション',
      noLogs: '監査ログなし',
      prev: '前へ',
      next: '次へ',
      table: {
        actor: '操作者',
        target: '対象',
        action: 'アクション',
        time: '時刻',
        ip: 'IP'
      },
      panel: {
        title: '監査ログ',
        actor: '操作者',
        target: '対象',
        action: 'アクション',
        entityType: 'エンティティタイプ',
        refundRequestId: '返金リクエストID',
        subscriptionId: 'サブスクリプションID',
        timestamp: 'タイムスタンプ',
        ipAddress: 'IPアドレス',
        beforeState: '変更前の状態',
        afterState: '変更後の状態',
        na: 'N/A'
      },
      subscriptionCard: {
        id: 'ID',
        teamId: 'チームID',
        teamName: 'チーム名',
        tier: 'ティア',
        title: 'タイトル',
        description: '説明',
        active: 'アクティブ',
        yes: 'はい',
        no: 'いいえ',
        country: '国',
        created: '作成日',
        updated: '更新日',
        stripeProductId: 'Stripe商品ID',
        features: '機能',
        prices: '価格',
        profitSplit: '利益配分',
        syncStatus: '同期ステータス',
        key: 'キー',
        badge: 'バッジ',
        amount: '金額',
        currency: '通貨',
        interval: '間隔',
        stripePriceId: 'Stripe価格ID',
        discount: '割引'
      },
      refundCard: {
        status: 'ステータス',
        user: 'ユーザー',
        email: 'メール',
        refundRequestId: '返金リクエストID',
        billingSubscriptionId: '請求サブスクリプションID',
        payment: '支払い',
        amount: '金額',
        provider: 'プロバイダー',
        interval: '間隔',
        subscriptionStatus: 'サブスクリプションステータス',
        providerPaymentId: 'プロバイダー支払いID',
        reason: '理由',
        approval: '承認',
        providerRefundId: 'プロバイダー返金ID',
        providerSubscriptionId: 'プロバイダーサブスクリプションID',
        rejection: '却下',
        processedAt: '処理日時'
      },
      subscriptionsOverview: 'サブスクリプション概要',
      reporting: 'レポート',
      webhookLogs: 'Webhookログ'
    },
    liveStatsEngagement: {
      title: 'ライブスタッツエンゲージメント',
      liveUpdateImpressions: 'ライブ更新インプレッション',
      liveUpdateImpressionsDesc: 'ファンが実際に見たライブ統計更新の数。',
      activeViewingTime: 'アクティブ視聴時間',
      activeViewingTimeDesc: 'ライブスタッツが表示されていた合計時間',
      avgPerFan: 'ファンあたり平均',
      returnFrequency: '再訪頻度',
      returnFrequencyDesc: 'ファンがライブスタッツに戻った回数',
      avgReturnsPerFan: 'ファンあたり平均再訪回数',
      selectTeamPrompt: 'エンゲージメントインプレッションを表示するチームを選択してください'
    },
    /**
     * TIRI — 管理メニュー `/admin/tiri`（`screens/Admin/screens/Tiri`）と、一般設定 ›
     * リワードポイントの TIRI カード。
     *
     * トップレベルの `tiri` ネームスペース（ファン向けの Rate It ウェブランディング）とは
     * 別物です。こちらはファンには表示されない管理者向けの文言なので、統合しないでください。
     */
    tiri: {
      title: 'TIRI',
      // モジュール名はブランド表記のため全ロケールで英語のままです。バッジ・フィルター・
      // 集計タイル・設定カードが同じ表記を参照できるようキー化しています。`tagit`/`rateit`
      // はサーバーの module enum と同一の綴りです。
      modules: {
        tagit: 'Tag It',
        rateit: 'Rate It'
      },
      filters: {
        labelStatus: 'ラベル状態',
        module: 'モジュール',
        source: 'ソース',
        team: 'チームで絞り込み',
        all: 'すべて'
      },
      sources: {
        fancam: 'FanCam',
        direct: '直接アップロード'
      },
      status: {
        labeled: 'ラベル付与済み',
        pending: '未処理'
      },
      mediaTypes: {
        image: '画像',
        video: '動画'
      },
      // リストの列見出しと詳細パネルのラベルで共用します（`media`〜`uploadedAt` は列順）。
      fields: {
        media: 'メディア',
        modules: 'モジュール',
        source: 'ソース',
        uploader: 'アップロード者',
        team: 'チーム',
        status: 'ステータス',
        category: 'カテゴリー',
        inFeed: 'フィード掲載',
        uploadedAt: 'アップロード日時',
        // パネル専用 — リストには対応する列がありません。
        moderation: 'モデレーション',
        shownToFans: 'ファンへの表示'
      },
      feed: {
        live: '公開中',
        notLive: '非公開'
      },
      notApplicable: '該当なし',
      panel: {
        fallbackTitle: 'TIRI アイテム',
        // 英語版は所有格（"{{name}}'s upload"）ですが、日本語では「さん」を補って自然な
        // 表記にしています。
        title: '{{name}} さんのアップロード',
        unknownUploader: '不明',
        mediaAlt: 'TIRI メディア',
        sourceDirect: 'チームチャンネルからのアップロード（FanCam ではありません）',
        sourceFancam: 'FanCam チャレンジ',
        noCategory: 'これは Rate It のアイテムのため、設定するカテゴリーはありません。',
        categoryPlaceholder: '正しいカテゴリーを選択してください',
        yes: 'はい',
        no: 'いいえ',
        save: '保存',
        saving: '保存中...',
        selectCategoryFirst: '保存する前にカテゴリーを選択してください。',
        saved: 'Tag It のカテゴリーを保存しました。'
      },
      /** 一般設定 › リワードポイント › TIRI。 */
      settings: {
        title: 'TIRI',
        description: 'Tag It と Rate It モジュールのポイント設定',
        participationPoints: '参加ポイント',
        participationPointsDesc:
          'Tag It と Rate It を合わせて 5 回完了するごとに付与（組み合わせは自由）。0 の場合は付与しません',
        referralPoints: '紹介ポイント',
        referralPointsDesc: '招待により双方が獲得する数値としてファンに表示されます'
      }
    },
    /** 一般設定 › リワードポイント › 紹介プロンプトのスヌーズ（FanCam ＋ Rate It）。 */
    referralSnooze: {
      title: '紹介プロンプトのスヌーズ',
      description:
        'FanCam チャレンジと Rate It の両方の「友達を招待」プロンプトに適用されます。断った回数はそれぞれ別々にカウントされます。',
      label: '紹介プロンプトのスヌーズ期間',
      placeholder: '長さ',
      hint: 'ファンが {{length}} 以内に招待プロンプトを 2 回断ると、その後 {{length}} は再び表示されません。',
      saveInvalid: '「紹介プロンプトのスヌーズ期間」が無効です。入力欄の下のメッセージを確認してください。',
      units: {
        minutes: '分',
        hours: '時間',
        days: '日'
      },
      errors: {
        maxMinutes: '分は最大 60 までです。それ以上は「時間」を使用してください。',
        maxHours: '時間は最大 24 までです。それ以上は「日」を使用してください。',
        invalid: '1 分以上の長さを、分単位の整数で入力してください。'
      },
      duration: {
        day: '{{count}} 日',
        hour: '{{count}} 時間',
        minute: '{{count}} 分'
      }
    },
    /** 管理 › インサイト › アイテム別アクティビティドロワー（`ItemActivityDrawer.js`）。 */
    insights: {
      /**
       * A FanCam / TIRI item whose document is gone. Its events are kept — the engagement
       * happened — so the row stays, marked with this, and labelled from what the delete event
       * recorded about it.
       */
      deleted: '削除済み',
      /** `{{date}}` is the delete event's date, already formatted for the locale. */
      deletedOn: '{{date}} に削除',
      /** /admin/insights/goalrush から取得する GoalRush 分析（ブリーフ §7）。チーム単位または全チーム。 */
      goalrushStats: {
        title: 'GoalRush 分析',
        open: 'GoalRush 分析を開く',
        refresh: 'GoalRush 分析を更新',
        scopeAllTeams: '全チーム',
        scopeAllTime: '全期間',
        dailyCardTitle: 'GoalRush アナリティクス',
        viewMore: 'もっと見る',
        subtitle: '選択期間に開始したセッション。チーム未選択時は全チーム。',
        empty: 'この期間のデータはありません',
        groups: {
          volume: 'ボリューム',
          rates: 'ゲームプレイ',
          milestones: 'マイルストーン',
          sessions: 'セッション',
          engagement: 'エンゲージメント',
          events: 'イベント'
        },
        sessions: 'セッション数',
        sessionsHint: '期間内に開始',
        kicks: '総キック数',
        goals: '総ゴール数',
        kicksPerSession: 'セッションあたりのキック',
        goalsPerSession: 'セッションあたりのゴール',
        fans: 'アクティブ参加者',
        fansHint: '参加またはキックしたファン',
        kickers: 'キックしたファン',
        goalRate: 'ゴール率',
        goalRateHint: 'ゴール ÷ キック',
        blockRate: 'ディフェンダーブロック率',
        blockRateHint: 'ブロック ÷ キック（ディフェンダーまたはボール）',
        defenderHitRate: 'ディフェンダー接触率',
        defenderHitRateHint: 'ディフェンダーに当たったキック',
        collisionRate: 'ボール同士の衝突率',
        collisionRateHint: '他のファンのボールに当たったキック',
        nearMissRate: 'ニアミス率',
        milestone: {
          kicks: {
            completion: 'キックマイルストーン達成率',
            medianTime: 'キックマイルストーン到達時間'
          },
          goals: {
            completion: 'ゴールマイルストーン達成率',
            medianTime: 'ゴールマイルストーン到達時間'
          },
          reachedOf: '終了した {{ended}} セッション中 {{reached}}',
          avg: '中央値 · 平均 {{value}}'
        },
        endedSessions: '終了したセッション',
        autoResets: '自動リセット',
        autoResetsHint: '目標達成または時間切れ',
        avgSessionDuration: '平均セッション時間',
        avgSessionDurationHint: '一時停止時間を除く',
        pausedByOverride: 'オーバーライドによる一時停止',
        pausedByOverrideHint: 'オーバーライドのために一時停止したデフォルトセッション',
        avgKicksPerFan: 'ユーザーあたりのキック',
        avgGoalsPerFan: 'ユーザーあたりのゴール',
        avgSessionsPerFan: 'ファン1人あたりのセッション',
        participationEvents: '参加イベント',
        goalEvents: 'ゴールイベント',
        avgPerSec: 'イベント / 秒（平均）',
        avgPerSecHint: 'アクティビティのあった分の平均',
        peakPerSec: 'イベント / 秒（ピーク）',
        peakPerSecHint: '最も多かった1分間',
        resetReasons: 'リセット理由',
        resetReasonsHint: 'セッションが終了した理由',
        endReason: {
          target_reached: '目標達成',
          target_not_reached: '時間切れ',
          admin_override: '管理者によるオーバーライド',
          disabled: 'オフ',
          active: '進行中',
          unknown: '不明'
        },
        daily: '日別キック数',
        dailyHint: 'キック数（横にゴール数）',
        kicksCount: '{{value}} キック',
        goalsCount: '{{value}} ゴール'
      },
      /** /admin/insights/fanchat から取得する、チームと期間ごとの FanChat 2.0 の数値。 */
      fanchatTopics: {
        title: 'FanChat 2.0 トピックチャット',
        messages: 'メッセージ',
        previews: 'プレビュー',
        joins: '参加',
        joinRate: '参加率',
        joinRateHint: '参加 ÷ プレビュー',
        topicsCreated: '作成されたチャット',
        topicsCreatedHint: '下書きを含む',
        topicsPublished: '公開されたチャット',
        medianFirstResponse: '初回返信までの時間（中央値）',
        activeNow: '現在アクティブ',
        activeNowHint: '期間に関係なく現在の値',
        /** 無料プランの利用枠とフォローに関する数値（チームと期間ごと）。 */
        access: {
          title: 'FanChatアクセス',
          freeFansUsed: '投稿・返信した無料プランのファン',
          limitReachedFans: '上限に達したファン',
          limitReachedPosts: '投稿上限に到達',
          limitReachedReplies: '返信上限に到達',
          paywallLimitShown: '上限時にペイウォールを表示',
          followPromptShown: 'フォロー案内を表示',
          followRefused: 'フォロー未済で拒否',
          noData: 'まだデータがありません',
          sinceHint: '{{date}} 以降を集計'
        },
        /** FanChat一覧のトピック行の下に出る1行。 */
        topic: {
          by: '作成者: {{name}}',
          published: '公開 {{date}}',
          membersNow: '現在 {{count}} 人',
          messages: 'メッセージ {{count}}',
          previews: 'プレビュー {{count}}',
          joins: '参加 {{count}}',
          firstResponse: '初回返信 {{time}}',
          status: { published: '公開中', deleted: '削除済み', draft: '下書き' }
        },
        duration: {
          seconds: '{{s}}秒',
          minutes: '{{m}}分{{s}}秒',
          hours: '{{h}}時間{{m}}分'
        }
      },
      /** モジュール別アイテム一覧：並び替えと（TIRIのみ）絞り込み付き。 */
      items: {
        /** `{{module}}` は製品名（FanCam、TIRIなど）で、翻訳しない。 */
        title: '{{module}}のアイテム',
        sort: {
          label: 'アイテムを並び替え',
          reach: 'リーチが多い順',
          events: 'イベントが多い順',
          recent: '最近のアクティビティ順'
        },
        sortHint: {
          reach: 'リーチ（閲覧・表示）の多い順',
          events: '総エンゲージメントの多い順',
          recent: '最新のアクティビティ順'
        },
        playerStatsNote:
          '同じ試合のライブ試合スタッツウィジェットの閲覧と個別の選手カードの閲覧を合算しています。行を開くと各イベントの内容を確認できます。',
        refresh: '{{module}}のアイテム一覧を更新',
        close: '閉じる',
        empty: 'まだ何もありません',
        emptySub: 'このフィルターに一致する{{module}}のアクティビティはありません。',
        events: 'イベント',
        relative: {
          justNow: 'たった今',
          minutes: '{{count}}分前',
          hours: '{{count}}時間前',
          days: '{{count}}日前'
        },
        range: '{{total}}件中 {{start}}–{{end}}',
        prev: '前へ',
        next: '次へ'
      },
      drawer: {
        close: '閉じる',
        goalrushChip: '{{kicks}} キック · {{goals}} ゴール',
        /** ドロワーの第 1 階層：このアイテムに関与したファン一覧。 */
        people: 'ファン',
        backToPeople: 'ファン一覧',
        /** `{{count}}` はアイテム全体ではなく、そのファン自身のイベント数。 */
        personEvents: '{{count}}件のイベント',
        lastActive: '最終 {{time}}',
        noPeople: 'まだ誰もいません',
        noPeopleSub: '現在のフィルターでは、このアイテムへのファンの反応はありません。',
        /**
         * まとめられたリーチイベントの回数。「このアイテムを閲覧 ×12」のように動詞のあとに
         * 続けて表示するため、単独で使う `personEvents` とは別のキーにしている。
         */
        repeatCount: '×{{count}}',
        /** Note above a fan's timeline: why one fan's views can appear as several rows. */
        groupedByHour: '繰り返しの閲覧は、発生した時間（1時間単位）ごとにまとめて表示されます。',
        deletedUser: '削除されたユーザー',
        /**
         * 記号は JSX で連結せず文字列に含める。ロケール側で記号の有無・位置・前後の空白を
         * 調整できるようにするため（日本語では ASCII 半角スペースを入れたくない）。
         */
        tagCorrect: '✓ 正解',
        tagWrong: '✗ 不正解',
        /**
         * `metadata.trigger` の値をそのままキーにしている。Tag It のヒントはファンに届く経路が
         * 2 通りあり、区別できるのはこのフィールドだけ。`wrongGuess` は
         * `api/tiri/tagit/submit.ts`、`tap` は写真タップ時にアプリが記録する。
         */
        hintTrigger: {
          tap: '写真をタップ',
          wrongGuess: '誤答のあと'
        },
        /**
         * イベント種別ごとの表示文言。「<ファン名> が <文言>」として読まれる。
         *
         * ネスト構造がそのまま eventType。`eventType` は元から
         * ドット区切り（`tiri.tagit.submit`）で、i18next のキー区切りも '.' なので、
         * 値をそのままキーに埋め込んで参照している。JS 側に対応表はない。
         *
         * 各セグメントはサーバーが書き込む `eventType` と完全に一致する必要がある。
         * ここで名前を変えても改名にはならず、参照が外れて下の `bucketFallback` に落ちるだけ。
         */
        events: {
          fancam: {
            view: 'この投稿を閲覧',
            colorReact: 'カラーでリアクション',
            react: 'リアクション',
            comment: 'コメントを投稿',
            repost: 'この投稿をリポスト',
            delete: 'この投稿を削除',
            challenge: { create: 'この投稿を作成' },
            live: { create: 'この投稿を作成' },
            arFilter: { apply: 'ARフィルターを適用' }
          },
          tiri: {
            upload: 'このアイテムをアップロード',
            /** A moderator (or a FanCam delete) removed the item. */
            delete: 'このアイテムを削除',
            tagit: {
              view: 'Tag Itでこのアイテムを閲覧',
              submit: 'このアイテムにタグ付け',
              hint: 'ヒントを使用',
              definition: 'カテゴリーの説明を表示'
            },
            rateit: {
              view: 'Rate Itでこのアイテムを閲覧',
              submit: 'このアイテムを評価',
              /**
               * 「送信した」ではなく「開いた」。`tiri.rateit.share` はファンがシェア画面に
               * 到達した時点で記録される（モバイル `RateItFeed.tsx` の `openShare`）。実際に
               * 送信されたかどうかは記録していないため、「シェアした」と訳すと行が示す以上の
               * 意味になってしまう。この区別はどのロケールでも維持すること。
               */
              share: 'このモーメントのシェア画面を開いた'
            }
          },
          goalrush: {
            view: 'GoalRush を開いた',
            kick: 'このセッションで'
          },
          fanwave: {
            view: 'ウェーブを表示',
            tap: 'ウェーブをタップ',
            /**
             * 「目標達成を見た」だけを示す。アプリはカードが画面に表示されている間に「Wave complete!」
             * のアニメーションが再生されると `fanwave.goalReached.view` を記録する。このファンの
             * タップで目標に届いたという意味ではない。この区別はどのロケールでも維持すること。
             */
            goalReached: { view: 'ウェーブの目標達成を表示' }
          },
          fanchat: {
            view: 'スレッドを表示',
            message: 'コメントを投稿',
            react: 'メッセージにリアクション',
            topic: {
              preview: 'チャットのプレビューを表示',
              join: 'チャットに参加',
              leave: 'チャットから退出',
              message: 'メッセージを送信',
              message_delete: 'メッセージを削除',
              draft: 'チャットの下書きを保存',
              publish: 'チャットを公開',
              delete: 'チャットを削除'
            },
            allowance: { used: '無料の投稿または返信を使用' },
            limit: { reached: '無料の上限に到達' },
            follow: { refused: 'フォロー未済で拒否された', prompt_shown: 'フォローを案内された' },
            paywall: { limit_shown: '無料の上限でペイウォールを表示' }
          },
          predictions: { vote: '予想を投稿' },
          quizzes: { answer: 'クイズに回答' },
          polls: { submit: '投票に参加' },
          playerStats: { liveEngagement: 'ライブスタッツを確認' },
          rewards: {
            carousel: { view: 'リワード一覧を表示' },
            card: { tap: 'このリワードをタップ' }
          },
          ptw: { gloryboard: { view: 'GloryBoardを表示' } }
        },
        /**
         * `events` に該当がない場合に使用する。CMS がまだ名前を知らないイベントを
         * モジュールが送ってきたケース。全イベントが必ず持つ bucket をキーにしているので、
         * 表示が壊れる代わりに「どの種類の関与か」だけは伝わる。
         */
        bucketFallback: {
          reach: 'これを閲覧',
          activity: 'これを操作',
          creation: 'これを作成',
          participation: 'これに参加'
        },
        /** 最終手段。bucket も認識できなかったイベント。 */
        genericAction: '何らかの操作'
      }
    },
    reporting: {
      webhooks: {
        title: 'Webhook配信ログ',
        subtitle: 'Webhookの配信状況を監視し、失敗を調査します。機密データは表示されません。',
        securityNotice:
          'このビューには非機密メタデータのみが表示されます。ペイロード内容、認証ヘッダー、署名、個人情報、内部シークレットは一切表示されません。',
        payloadNotice:
          'ペイロード内容はセキュリティのために非表示です。配信メタデータのみが表示されます。',
        empty: '選択したフィルターに一致するWebhookログが見つかりません。',
        totalResults: '{{count}} 件',
        exportCsv: 'CSVエクスポート',
        exporting: 'エクスポート中…',
        filters: {
          label: 'フィルター',
          from: '開始日',
          to: '終了日',
          eventType: 'イベントタイプ',
          status: 'ステータス',
          allTypes: '全タイプ',
          allStatuses: '全ステータス',
          apply: '適用',
          clear: 'クリア'
        },
        status: {
          pending: '保留中',
          processing: '処理中',
          completed: '完了',
          failed: '失敗',
          retrying: '再試行中'
        },
        summary: {
          total: '合計',
          success: '成功',
          completed: '完了',
          failed: '失敗',
          processing: '処理中',
          successRate: '成功率'
        },
        cols: {
          eventId: 'イベントID',
          eventType: 'イベントタイプ',
          endpoint: 'エンドポイント',
          timestamp: 'タイムスタンプ (UTC)',
          status: 'ステータス',
          httpCode: 'HTTPコード',
          retries: 'リトライ',
          duration: '処理時間',
          errorCategory: 'エラー種別'
        },
        pagination: {
          page: '{{page}} / {{totalPages}} ページ',
          prev: '前へ',
          next: '次へ'
        }
      }
    },
    ctaPresets: {
      defaultPresets: 'デフォルト定型メッセージ',
      customPresets: 'カスタム定型メッセージ',
      addACustomPreset: 'カスタム定型メッセージを追加',
      englishMessage: '英語のメッセージ',
      japaneseMessage: '日本語のメッセージ（任意）',
      noCustomPresetsYet: 'カスタム定型メッセージはまだありません。',
      teamPresets: 'チーム定型メッセージ',
      noTeamPresetsYet: 'カスタム定型メッセージはまだありません。'
    },
    p4pDay: {
      tab: 'P4Pデー',
      campaignTitle: 'P4Pデー キャンペーン',
      campaignDescription:
        'ファンが登録できる期間です。判定はすべてサーバー側で行われ、端末の時計が締め切りを決めることはありません。',
      enabledLabel: 'キャンペーン有効',
      enabledDesc: '緊急停止スイッチ。オフにすると、以下の期間を変更せずに登録を直ちに停止します。',
      startsAt: '開始日時（UTC）',
      endsAt: '終了日時（UTC）',
      inTokyo: '東京時間: {{time}}',
      currently: '現在:',
      active: '実施中 — ファンの登録を受付けています',
      notActive: '停止中',
      badgesTitle: 'バッジ配布状況',
      allBadges: 'すべてのバッジ',
      remaining: '残り <num>{{count}}</num>',
      awarded: '{{count}}個付与済み',
      total: '合計{{count}}個',
      disabledTitle: 'この環境ではキャンペーンが無効です',
      disabledDescription:
        'サーバーで P4P_DAY_CAMPAIGN_ENABLED が設定されていないため、この環境にキャンペーンは存在せず、設定もできません。未設定の間は、以前に保存された期間にかかわらず、ファンの登録、バッジの付与、チームの自動フォローは行われません。参加するには設定してサーバーを再起動してください。',
      disabledSectionDescription: 'この環境はP4Pデー キャンペーンに参加していません。',
      loadFailed: 'P4Pデー キャンペーンを読み込めませんでした。',
      datesRequired: '開始日時と終了日時の両方が必要です。',
      endBeforeStart: '終了日時は開始日時より後である必要があります。',
      save: '変更を保存',
      saving: '更新中...',
      award: {
        menuItem: 'P4Pデー バッジを付与',
        title: 'P4Pデー バッジを付与',
        intro:
          'このファンはP4Pデー バッジを持っていません。色を選んで手動で付与してください。アプリで獲得したバッジと同じく在庫から差し引かれます。',
        loading: '読み込み中…',
        switchedOff: 'この環境ではP4Pデーが無効になっています。',
        notActive: 'P4Pデー キャンペーンが実施中ではないため、バッジを付与できません。',
        allSoldOut:
          'すべての色のバッジが在庫切れです。「一般設定 → P4Pデー」で在庫を補充してください。',
        outOfStock: '在庫切れ',
        left: '残り {{remaining}} / {{total}}',
        awardButton: 'バッジを付与',
        confirmText:
          '@{{username}} に {{color}} バッジを付与しますか？在庫が1つ減り、キャンペーンのチームを自動フォローします。この画面から取り消すことはできません。',
        confirmButton: 'はい、付与します',
        cancel: 'キャンセル',
        close: '閉じる',
        awarded: '{{color}} バッジ #{{badgeNo}} を付与しました。',
        revokedNote: 'このファンのバッジは {{date}} に削除されました。付与すると新しいバッジが渡されます。'
      },
      fans: {
        allTitle: 'すべてのバッジ',
        count: 'ファン {{count}}人',
        close: '閉じる',
        empty: 'このバッジを持っているファンはまだいません。',
        fanId: 'ファンID',
        awardedOn: '付与日時 {{date}}',
        byAdmin: '管理者',
        handedOver: '受け渡し済み',
        delete: 'バッジを削除',
        confirm:
          'このバッジを削除しますか？在庫に戻ります。ファンはアプリで再取得できませんが、管理者は再度付与できます。',
        confirmNoRestock:
          'それでもこのバッジを削除しますか？在庫には戻りません。ファンはアプリで再取得できませんが、管理者は再度付与できます。',
        handedOverWarning: 'このファンはすでにブースで景品を受け取っています。',
        confirmButton: 'はい、削除します',
        cancel: 'キャンセル',
        revokedRestocked: 'バッジを削除し、在庫に戻しました。',
        revokedNotRestocked: 'バッジを削除しました。景品は受け渡し済みのため、在庫は変わりません。',
        revokedUnnumbered: 'バッジを削除しました。番号付け導入前に付与されたバッジのため、在庫には戻していません。',
        pageRange: '{{total}}件中 {{from}}–{{to}}件',
        searchPlaceholder: '名前・ユーザー名・メール・ファンID・バッジ番号で検索',
        searchClear: '検索をクリア',
        matches: '該当 {{count}}人',
        noMatches: '「{{query}}」に該当するファンはいません。',
        prevPage: '前のページ',
        nextPage: '次のページ'
      }
    },
    // チームの FanChat 2.0 アクセス設定（TeamPanel/components/FanChatAccessPanel.js）。
    fanChatAccess: {
      title: 'FanChatアクセス',
      description:
        'このチームで、FanChat 2.0のどの操作にFanChatアクセス（プラン・キャンペーン・バイパス）が必要かを選びます。チャットの閲覧とプレビューは誰でもできます。',
      join: {
        label: 'チャットへの参加にFanChatアクセスが必要',
        hint: 'オフの場合、ログインしているファンなら誰でもチャットに参加できます。',
        confirm:
          'FanChatアクセスのないファンがチャットに参加しようとすると、ペイウォールが表示されます。続けますか？'
      },
      send: {
        label: 'メッセージの送信にFanChatアクセスが必要',
        hint: '自分のメッセージの削除も含みます。オフの場合、ログインしているファンなら誰でも送信できます。',
        confirm:
          'FanChatアクセスのないファンがメッセージを送信しようとすると、ペイウォールが表示されます。続けますか？'
      },
      start: {
        label: 'チャットの作成にFanChatアクセスが必要',
        hint: '下書き・編集・公開も含みます。オフの場合、ログインしているファンなら誰でもチャットを作成できます。',
        confirm:
          'FanChatアクセスのないファンがチャットを作成しようとすると、ペイウォールが表示されます。続けますか？'
      },
      limit: {
        label: 'ファン1人あたりの公開チャット数',
        hint: 'このチームで1人のファンが同時に公開できるチャットの上限です。空欄にすると上限なしになります。すでに公開中のチャットはそのまま残ります。',
        none: '上限なし',
        save: '保存',
        invalid: '1〜{{max}}の整数を入力するか、上限なしの場合は空欄にしてください。'
      },
      turnOn: 'オンにする',
      cancel: 'キャンセル',
      lastChangedBy: '最終変更：{{date}}（{{username}}）',
      lastChanged: '最終変更：{{date}}',
      usingDefaults: 'デフォルト設定を使用中（すべてオン・チャット数の上限なし）',
      loadFailed: 'FanChatアクセス設定を読み込めませんでした。'
    },
    // 通報画面と詳細パネルの FanChat 2.0 エンティティ。
    reports: {
      entityTypes: {
        fanchatTopic: 'FanChatトピック',
        fanchatMessage: 'FanChatメッセージ'
      },
      fanchatTopic: {
        heading: '通報されたFanChatトピック',
        unavailable: 'FanChatトピックを表示できません',
        removeConfirm:
          'このチャットを削除しますか？FanChatから消え、すべてのメンバーに削除されたことが通知されます。'
      },
      fanchatMessage: {
        heading: '通報されたFanChatメッセージ',
        unavailable: 'FanChatメッセージを表示できません',
        deletedNote: '削除済みです。通報された時点のテキストを表示しています。',
        removeConfirm: 'このメッセージを削除しますか？チャットの全員に削除済みとして表示されます。'
      },
      remove: '削除',
      cancel: 'キャンセル'
    },
    // 一般設定 → 通知の各行（NotificationsTab.js）。
    notifications: {
      fanChatTopicFirstResponse: {
        label: 'FanChat：あなたのチャットへの最初の返信',
        desc: '他の人がチャットに初めて投稿したとき、チャットの作成者に一度だけ送信されます。'
      },
      fanChatTopicReply: {
        label: 'FanChat：あなたのメッセージへの返信',
        desc: 'ファンのメッセージに誰かが返信したときに送信されます。1分以内の返信はまとめて送られます。'
      },
      fanChatTopicDigest: {
        label: 'FanChat：新着メッセージのまとめ',
        desc: 'チャットごとに最大15分に1回、チャットを開いておらず通知をオンにしているメンバーに送信されます。'
      },
      fanChatTopicDeleted: {
        label: 'FanChat：チャットの削除',
        desc: 'チャットが削除されたとき、すべてのメンバーに送信されます。'
      }
    }
  },
  pollQuizProfile: {
    // Shared (poll + quiz profile sections)
    add: '追加',
    edit: '編集',
    delete: '削除',
    deleting: '削除中…',
    close: '閉じる',
    activate: '有効化',
    deactivate: '無効化',
    inactive: '無効',
    live: 'ライブ',
    chipClosed: '終了',
    seeAllCount: 'すべて表示（{{count}}）',
    seenThemAll: 'すべて表示しました。',
    // Polls section
    pollsTitle: '投票',
    allPolls: 'すべての投票',
    noPollsYet: 'まだ投票がありません。',
    createFirstPoll: '最初の投票を作成',
    createFirstPollSub: 'ファンに質問しよう。投票でポイント獲得。',
    deletePollHeading: '投票を削除しますか？',
    deletePollText: 'この操作は取り消せません。既存の投票は削除されます。',
    pollDeleted: '投票を削除しました。',
    pollDeleteError: '投票を削除できませんでした。もう一度お試しください。',
    pollSaved: '投票を保存しました。',
    chipScheduled: '予約済み',
    chipHidden: '非表示',
    chipAuto: '自動',
    gameDay: '試合日',
    pollLabel: '投票',
    gameDayPoll: '試合日の投票',
    viewResults: '結果を表示',
    voteNow: '今すぐ投票',
    pts: '{{count}}ポイント',
    modalPoll: '投票',
    statusOpen: '公開中',
    statusPollClosed: '投票終了',
    submitting: '送信中…',
    earnPtsForVoting: '投票で{{count}}ポイント獲得。投票は変更できません。',
    voteSubmittedConfirm: '投票を送信しました。投票は変更できません。',
    voteSubmittedConfirmPts: '投票を送信しました · +{{points}}ポイント。投票は変更できません。',
    toastVoteSubmitted: '投票を送信しました。',
    toastVoteSubmittedPts: '投票を送信しました · +{{points}}ポイント',
    thisPollClosed: 'この投票は終了しました。',
    totalSubmissions: '合計{{count}}件の回答',
    // Quick Quiz section
    quizTitle: 'クイッククイズ',
    allQuizzes: 'すべてのクイッククイズ',
    noQuizzesYet: 'まだクイズがありません。',
    createSingleQuiz: '単一クイズを作成',
    createSingleQuizSub: 'デイリーまたはハーフタイムのクイズ1件',
    bulkCreate: '一括事前作成',
    bulkCreateSub: '7 / 15 / 30日分のデイリーセット',
    createFirstQuiz: '最初のクイズを作成',
    createFirstQuizSub: '毎日の質問でファンを盛り上げよう。正解でポイント獲得。',
    deleteQuizHeading: 'クイズを削除しますか？',
    deleteQuizText: 'この操作は取り消せません。既存のユーザー回答は保持されます。',
    quizDeleted: 'クイズを削除しました。',
    quizSaved: 'クイズを保存しました。',
    quizzesCreated: '{{count}}件のクイズを作成しました。',
    chipAnswered: '回答済み',
    chipComingUp: 'まもなく開始',
    actionPlay: 'プレイ',
    actionViewResult: '結果を表示',
    signInToPlay: 'ログインしてプレイ',
    signInToPlaySub: 'Playaz4Playazに参加してクイズに回答し、ポイントを獲得しよう。',
    signUp: '新規登録',
    resultCorrect: '正解です！',
    resultNotQuite: '惜しい。',
    earnedPts: '{{count}}ポイント獲得しました。',
    betterLuck: '次回また挑戦してください。',
    submit: '送信',
    ptsAvailable: '獲得可能{{count}}ポイント',
    toastCorrect: '正解！',
    toastSubmitted: '送信しました。'
  },
  /**
   * TIRI — Rate It のウェブ用ランディング（`screens/RateIt`）。
   *
   * 共通のキーはモバイル（`playaz4playaz-mobile` の `tiri.rateIt.*`）の日本語訳をそのまま
   * 使用しています。`referral.*` と `auth.*` はウェブ専用 — モバイルは招待を「送る」側、
   * ウェブは「受け取る」側なので、モバイルに対応する文言がありません。
   */
  tiri: {
    anonymousFan: 'ファン',
    creatorPoints: '{{points}} ポイント',
    viewCount: '{{views}} 回視聴',
    sponsorPlaceHolder: 'TIRI',
    rateIt: {
      caption: 'このファンモーメントを評価 – Solid、Great、Epic',
      noContent: '今は評価できる瞬間がありません。またあとで確認してください。',
      loadError: 'Rate It を読み込めませんでした。',
      submitError: '評価を保存できませんでした。もう一度お試しください。',
      sharedUnavailable: 'その瞬間はもう表示できません — 代わりに他の瞬間を評価できます。',
      close: '閉じる',
      previousMoment: '前の瞬間',
      nextMoment: '次の瞬間',
      // 英語版と同じく、バックエンドの enum が定める rating の値（solid/great/epic）で
      // 引きます。ティア名はブランド表記のため翻訳しません。
      ratings: {
        solid: 'Solid',
        great: 'Great',
        epic: 'Epic'
      },
      milestone: {
        // `_plural` は日本語には不要です。i18next の複数形ルールでは日本語は単一形なので、
        // count の値にかかわらず接尾辞なしのこのキーだけが参照されます（英語版には
        // `title_plural` があり、そちらは必要です）。キー数が英語版と一致しないのは
        // このためで、欠落ではありません。`{{count}}` を含む以下のキーも同様です。
        title: '{{count}}件のモーメントを評価しました！',
        continue: '続ける'
      },
      referral: {
        // <strong> は <Trans> が解釈するマークアップです。`RateItReferralBanner` の
        // `components` マップとタグ名を揃えてください。
        banner:
          '<strong>{{name}}</strong>から招待されています。{{count}}件のモーメントを評価すると、あなたと{{name}}の両方に{{points}}ポイントが付与されます。',
        offer: '{{count}}つの瞬間を評価すると、お互いに{{points}}ポイント獲得。',
        // 招待リンクの終点：この招待はすでに完了しています。招待「リンク」ごとの判定なので、
        // 別の招待リンクであれば通常どおりフィードが開きます。
        completedTitle: 'この招待はすでに完了しています',
        // 完了の結末は3通りあります。実際にポイントが付与された場合は `completedBody`、
        // 完了したが付与が0だった場合（報酬が0に設定されていた）は `completedBodyNoPoints`。
        //「0ポイント獲得」と書くと不具合に見えるためです。送信者が特定できない、または
        // 付与額の記録がない場合は `completedBodyNoSender`。
        completedBody:
          'あなたと{{name}}は、すでに{{points, number}}ポイントを一緒に獲得しています。',
        completedBodyNoPoints: 'あなたと{{name}}は、すでにこの招待を完了しています。',
        completedBodyNoSender: 'この招待はすでに完了しています。',
        awardBody:
          '招待を完了しました。あなたと{{name}}にそれぞれ{{points, number}}ポイントが付与されました。',
        awardBodyNoSender:
          '招待を完了しました。あなたと友だちにそれぞれ{{points, number}}ポイントが付与されました。'
      },
      auth: {
        signUpTitle: '評価を始めるには新規登録を行ってください',
        signUpSubtitle:
          'Playaz4Playazで無料アカウントを作成して、モーメントを評価すると友だちと一緒にポイントを獲得できます。',
        loginTitle: 'サインイン',
        loginSubtitle:
          'このモーメントを評価して友だちとともにポイントを獲得するには、ログインしてください。',
        createAccount: 'アカウントを作成する',
        haveAccount: 'すでにアカウントをお持ちですか？',
        needAccount: 'アカウントが必要ですか？',
        signIn: 'ログイン',
        signUp: '登録'
      }
    }
  },
  countries: {
    sweden: 'スウェーデン',
    poland: 'ポーランド',
    france: 'フランス',
    japan: '日本',
    southAfrica: '南アフリカ',
    germany: 'ドイツ',
    unitedKingdom: 'イギリス',
    unitedStates: 'アメリカ',
    northMacedonia: '北マケドニア'
  },
  referral: {
    selfReferralTitle: '自分ではなく友だちを招待してください',
    selfReferralBody:
      'このチャレンジは、あなたとあなたを招待した友だちの両方が対象です。参加するには、友だちから送られたリンクを開いてください。',
    startFailedTitle: 'チャレンジを開始できませんでした',
    startFailedBody: '問題が発生しました。通信環境を確認して、もう一度お試しください。',
    tryAgain: '再試行する',
    yourFriend: 'お友達',
    alreadyCompletedTitle: 'このチャレンジはすでに完了しています',
    alreadyCompletedBody:
      'あなたと{{friendName}}は、このチャレンジで既に{{points, number}}ポイントを獲得しています。',
    authGateBody: '{{teamName}}のFanCam Challengeを解放するには、新規登録を行ってください。',
    authGateBodySignIn: '{{teamName}}のFanCam Challengeを解放するには、ログインしてください。',
    awardTitle: 'やった！',
    awardBonusPts: '+{{points}}ポイント',
    // `_plural` は日本語には不要です（milestone.title と同じ理由）。
    awardBody:
      '<strong>{{count}}件のFanCamモーメント</strong>を閲覧しました。あなたと友だちの両方に<strong>{{points}}ポイント</strong>が付与されました。',
    awardContinue: '続けて遊ぶ'
  }
};
